import React, { useEffect, useState } from "react";
import style from "./Top.module.css";
import { NavLink, useHistory } from "react-router-dom";
import { Button as Butt, Menu, MenuItem } from "@mui/material";
import { logout } from "../../../../slices/auth/authSlice";
import { useDispatch } from "react-redux";
import { Button as ButtonModal, Modal } from "react-bootstrap";
import { clearCompanies } from "../../../../slices/company/companySlice";
import moment from "moment";
import logoCartena from "../../../../assets/images/logo.png";
import logoCartenaHover from "../../../../assets/images/logo_hover.png";
import { MdMenu } from "react-icons/md";
import {
  FaBuilding,
  FaFileInvoiceDollar,
  FaPlusCircle,
  FaUserPlus,
  FaUsers,
} from "react-icons/fa";

export const loginIcon: React.SVGProps<SVGSVGElement> = (
  <svg
    version="1.1"
    id="Layer_1"
    x="0px"
    y="0px"
    width="24"
    height="24"
    viewBox="0 0 88.363 122.879"
  >
    <g>
      <path d="M42.078,64.589H3.118C1.396,64.589,0,63.179,0,61.439s1.396-3.149,3.118-3.149h38.958L29.405,43.778 c-1.137-1.298-1.017-3.281,0.268-4.429c1.285-1.148,3.248-1.027,4.385,0.271l17.238,19.742c1.059,1.208,1.027,3.009-0.02,4.179 L34.057,83.26c-1.137,1.298-3.1,1.419-4.385,0.271c-1.284-1.148-1.404-3.132-0.268-4.43L42.078,64.589L42.078,64.589z M47.434,122.786c-1.77,0.428-3.55-0.659-3.978-2.428s0.659-3.55,2.427-3.978c4.258-1.032,7.932-1.761,11.303-2.428 c15.99-3.168,24.566-4.866,24.566-27.147V34.258c0-20.817-9.068-22.512-24.086-25.318c-3.596-0.672-7.498-1.401-11.783-2.441 c-1.768-0.428-2.855-2.208-2.427-3.978c0.428-1.769,2.208-2.855,3.978-2.428c4.02,0.976,7.885,1.698,11.447,2.363 c18.383,3.436,29.482,5.51,29.482,31.801v52.548c0,27.705-10.443,29.773-29.912,33.63 C54.986,121.121,51.215,121.869,47.434,122.786L47.434,122.786z" />
    </g>
  </svg>
);

export const loginIconSmall: React.SVGProps<SVGSVGElement> = (
  <svg
    version="1.1"
    id="Layer_1"
    x="0px"
    y="0px"
    width="12"
    height="12"
    viewBox="0 0 88.363 122.879"
  >
    <g>
      <path d="M42.078,64.589H3.118C1.396,64.589,0,63.179,0,61.439s1.396-3.149,3.118-3.149h38.958L29.405,43.778 c-1.137-1.298-1.017-3.281,0.268-4.429c1.285-1.148,3.248-1.027,4.385,0.271l17.238,19.742c1.059,1.208,1.027,3.009-0.02,4.179 L34.057,83.26c-1.137,1.298-3.1,1.419-4.385,0.271c-1.284-1.148-1.404-3.132-0.268-4.43L42.078,64.589L42.078,64.589z M47.434,122.786c-1.77,0.428-3.55-0.659-3.978-2.428s0.659-3.55,2.427-3.978c4.258-1.032,7.932-1.761,11.303-2.428 c15.99-3.168,24.566-4.866,24.566-27.147V34.258c0-20.817-9.068-22.512-24.086-25.318c-3.596-0.672-7.498-1.401-11.783-2.441 c-1.768-0.428-2.855-2.208-2.427-3.978c0.428-1.769,2.208-2.855,3.978-2.428c4.02,0.976,7.885,1.698,11.447,2.363 c18.383,3.436,29.482,5.51,29.482,31.801v52.548c0,27.705-10.443,29.773-29.912,33.63 C54.986,121.121,51.215,121.869,47.434,122.786L47.434,122.786z" />
    </g>
  </svg>
);

export const userIcon: React.SVGProps<SVGSVGElement> = (
  <svg id="Layer_1" data-name="Layer 1" viewBox="0 0 122.88 110.44" height="24">
    <path d="M46.07,68.62a19.25,19.25,0,0,1-1.63-2c-1.2-1.65-2.33-3.37-3.42-5.1L35.6,52.89c-2.06-3-3.14-5.74-3.14-7.91s1.23-5,3.68-5.63a149.33,149.33,0,0,1-.21-15.61,19.7,19.7,0,0,1,.65-3.58,20.63,20.63,0,0,1,9.21-11.7,23.65,23.65,0,0,1,5-2.39c3.15-1.19,1.63-6,5.1-6.07C64-.21,77.33,6.73,82.53,12.36a20.56,20.56,0,0,1,5.31,13.33l-.33,14.2a4,4,0,0,1,2.93,2.92c.43,1.74,0,4.12-1.52,7.48h0c0,.11-.11.11-.11.22L82.63,60.7c-1.4,2.3-2.85,4.65-4.48,6.81-1.93,2.58-3.52,2.12-1.87,4.59,11.83,16.26,46.6,6,46.6,38.34H0C0,78.08,34.78,88.36,46.6,72.1c1.36-2,1-1.85-.53-3.48Z" />
  </svg>
);

export const userSmallIcon: React.SVGProps<SVGSVGElement> = (
  <svg id="Layer_1" data-name="Layer 1" viewBox="0 0 122.88 110.44" height="12">
    <path d="M46.07,68.62a19.25,19.25,0,0,1-1.63-2c-1.2-1.65-2.33-3.37-3.42-5.1L35.6,52.89c-2.06-3-3.14-5.74-3.14-7.91s1.23-5,3.68-5.63a149.33,149.33,0,0,1-.21-15.61,19.7,19.7,0,0,1,.65-3.58,20.63,20.63,0,0,1,9.21-11.7,23.65,23.65,0,0,1,5-2.39c3.15-1.19,1.63-6,5.1-6.07C64-.21,77.33,6.73,82.53,12.36a20.56,20.56,0,0,1,5.31,13.33l-.33,14.2a4,4,0,0,1,2.93,2.92c.43,1.74,0,4.12-1.52,7.48h0c0,.11-.11.11-.11.22L82.63,60.7c-1.4,2.3-2.85,4.65-4.48,6.81-1.93,2.58-3.52,2.12-1.87,4.59,11.83,16.26,46.6,6,46.6,38.34H0C0,78.08,34.78,88.36,46.6,72.1c1.36-2,1-1.85-.53-3.48Z" />
  </svg>
);

export const logoutIcon: React.SVGProps<SVGSVGElement> = (
  <svg
    version="1.1"
    id="Layer_1"
    x="0px"
    y="0px"
    width="89.149px"
    height="24"
    viewBox="0 0 89.149 122.88"
  >
    <g>
      <path d="M79.128,64.598H40.069c-1.726,0-3.125-1.414-3.125-3.157c0-1.744,1.399-3.158,3.125-3.158h39.057L66.422,43.733 c-1.14-1.301-1.019-3.289,0.269-4.439c1.288-1.151,3.257-1.03,4.396,0.271l17.281,19.792c1.061,1.211,1.029,3.019-0.02,4.19 l-17.262,19.77c-1.14,1.302-3.108,1.423-4.396,0.271c-1.287-1.151-1.408-3.139-0.269-4.44L79.128,64.598L79.128,64.598z M42.396,116.674c1.689,0.409,2.727,2.11,2.318,3.799c-0.409,1.689-2.109,2.728-3.799,2.318c-3.801-0.922-7.582-1.671-11.052-2.358 C10.426,116.583,0,114.519,0,86.871V34.188C0,7.96,11.08,5.889,29.431,2.46c3.572-0.667,7.448-1.391,11.484-2.371 c1.689-0.409,3.39,0.629,3.799,2.319c0.408,1.689-0.629,3.39-2.318,3.799c-4.291,1.041-8.201,1.771-11.805,2.445 C15.454,11.48,6.315,13.188,6.315,34.188v52.683c0,22.467,8.643,24.179,24.756,27.37C34.453,114.911,38.138,115.642,42.396,116.674 L42.396,116.674z" />
    </g>
  </svg>
);

export const logoutIconSmall: React.SVGProps<SVGSVGElement> = (
  <svg
    version="1.1"
    id="Layer_1"
    x="0px"
    y="0px"
    width="89.149px"
    height="12"
    viewBox="0 0 89.149 122.88"
  >
    <g>
      <path d="M79.128,64.598H40.069c-1.726,0-3.125-1.414-3.125-3.157c0-1.744,1.399-3.158,3.125-3.158h39.057L66.422,43.733 c-1.14-1.301-1.019-3.289,0.269-4.439c1.288-1.151,3.257-1.03,4.396,0.271l17.281,19.792c1.061,1.211,1.029,3.019-0.02,4.19 l-17.262,19.77c-1.14,1.302-3.108,1.423-4.396,0.271c-1.287-1.151-1.408-3.139-0.269-4.44L79.128,64.598L79.128,64.598z M42.396,116.674c1.689,0.409,2.727,2.11,2.318,3.799c-0.409,1.689-2.109,2.728-3.799,2.318c-3.801-0.922-7.582-1.671-11.052-2.358 C10.426,116.583,0,114.519,0,86.871V34.188C0,7.96,11.08,5.889,29.431,2.46c3.572-0.667,7.448-1.391,11.484-2.371 c1.689-0.409,3.39,0.629,3.799,2.319c0.408,1.689-0.629,3.39-2.318,3.799c-4.291,1.041-8.201,1.771-11.805,2.445 C15.454,11.48,6.315,13.188,6.315,34.188v52.683c0,22.467,8.643,24.179,24.756,27.37C34.453,114.911,38.138,115.642,42.396,116.674 L42.396,116.674z" />
    </g>
  </svg>
);
export const logoNewRow: React.SVGProps<SVGSVGElement> = (

<svg version="1.1" id="Warstwa_1" height={60} x="0px" y="0px"
viewBox="0 0 184.83 104.83">

<g>
  <g>
    <g>
      <path className={style.st0} d="M73.1,37.9c-0.01-0.64-0.08-1.26-0.23-1.88c-0.27-1.09-0.74-1.98-1.42-2.66c-0.59-0.59-1.27-0.93-2.02-1.03
				c-0.81-0.1-1.58,0.11-2.27,0.66c-0.83,0.65-1.62,1.38-2.43,2.08c-0.45,0.39-0.91,0.78-1.35,1.2c-0.08,0.08-0.14,0.27-0.14,0.41
				c0,0.16,0.08,0.29,0.23,0.34c0.21,0.06,0.42,0.13,0.62,0.25c0.38,0.24,0.74,0.5,1.11,0.76c0.17,0.12,0.32,0.13,0.49-0.03
				c0.79-0.71,1.59-1.38,2.38-2.09c0.28-0.25,0.57-0.4,0.91-0.43c0.86-0.08,1.68,0.82,1.77,2c0.09,1.05-0.23,1.86-0.89,2.43
				c-0.68,0.58-1.36,1.17-2.03,1.76c-0.8,0.68-1.59,1.38-2.39,2.04c-0.67,0.55-1.65,0.15-2.07-0.67c-0.17-0.34-0.37-0.63-0.65-0.78
				c-0.41-0.22-0.96-0.05-1.21,0.33c-0.39,0.6-0.42,1.27-0.22,1.82c0.21,0.59,0.55,1.06,0.92,1.47c0.54,0.59,1.15,0.97,1.86,1.12
				c0.78,0.17,1.52,0.09,2.23-0.35c0.49-0.31,0.94-0.72,1.39-1.11c1.01-0.87,2.01-1.75,3.02-2.62c0.67-0.58,1.3-1.19,1.73-2.13
				C72.87,39.92,73.08,38.95,73.1,37.9z M58.2,52.87c0.79,0.02,1.49-0.32,2.06-0.8c1.21-1.04,2.41-2.09,3.61-3.15
				c0.09-0.08,0.16-0.28,0.15-0.42c-0.01-0.12-0.12-0.26-0.21-0.33c-0.14-0.09-0.3-0.11-0.45-0.17c-0.4-0.16-0.78-0.39-1.13-0.69
				c-0.19-0.17-0.38-0.41-0.65-0.15c-0.58,0.54-1.18,1.05-1.78,1.56c-0.36,0.31-0.71,0.68-1.1,0.86c-1,0.45-1.93-0.31-2.19-1.69
				c-0.17-0.88,0.12-1.96,0.72-2.48c1.46-1.26,2.91-2.56,4.37-3.83c0.54-0.47,1.11-0.49,1.69-0.12c0.35,0.22,0.56,0.6,0.78,0.99
				c0.2,0.34,0.47,0.51,0.78,0.54c0.97,0.1,1.46-1.25,1.11-2.17c-0.32-0.83-0.79-1.46-1.38-1.97c-0.68-0.58-1.43-0.82-2.22-0.8
				c-0.76,0.02-1.46,0.37-2.1,0.92c-1.3,1.13-2.59,2.27-3.89,3.4c-0.54,0.46-1.03,0.98-1.41,1.68c-0.33,0.62-0.57,1.31-0.69,2.06
				c-0.18,1.09-0.13,2.17,0.16,3.2c0.32,1.1,0.84,2.02,1.6,2.68C56.7,52.59,57.42,52.87,58.2,52.87z"/>
      <path className={style.st0} d="M73.1,37.9c-0.03,1.05-0.24,2.02-0.65,2.93c-0.43,0.94-1.07,1.55-1.73,2.13c-1.01,0.87-2.01,1.75-3.02,2.62
				c-0.46,0.39-0.91,0.81-1.39,1.11c-0.7,0.44-1.45,0.52-2.23,0.35c-0.7-0.15-1.32-0.53-1.86-1.12c-0.37-0.41-0.7-0.88-0.92-1.47
				c-0.2-0.55-0.18-1.23,0.22-1.82c0.25-0.39,0.8-0.55,1.21-0.33c0.28,0.15,0.49,0.44,0.65,0.78c0.41,0.83,1.4,1.22,2.07,0.67
				c0.81-0.66,1.6-1.35,2.39-2.04c0.68-0.58,1.36-1.17,2.03-1.76c0.66-0.57,0.98-1.38,0.89-2.43c-0.1-1.18-0.91-2.08-1.77-2
				c-0.34,0.03-0.63,0.18-0.91,0.43c-0.79,0.7-1.59,1.38-2.38,2.09c-0.18,0.16-0.32,0.15-0.49,0.03c-0.37-0.26-0.73-0.53-1.11-0.76
				c-0.19-0.12-0.41-0.19-0.62-0.25c-0.15-0.04-0.23-0.17-0.23-0.34c0-0.14,0.06-0.33,0.14-0.41c0.44-0.42,0.89-0.81,1.35-1.2
				c0.81-0.7,1.6-1.42,2.43-2.08c0.69-0.54,1.45-0.76,2.27-0.66c0.75,0.09,1.42,0.43,2.02,1.03c0.68,0.68,1.15,1.56,1.42,2.66
				C73.02,36.64,73.09,37.26,73.1,37.9z"/>
      <path className={style.st0} d="M58.2,52.87c-0.79,0-1.51-0.28-2.17-0.85c-0.77-0.65-1.29-1.58-1.6-2.68c-0.3-1.03-0.34-2.11-0.16-3.2
				c0.12-0.75,0.36-1.44,0.69-2.06c0.37-0.7,0.87-1.22,1.41-1.68c1.3-1.13,2.59-2.27,3.89-3.4c0.64-0.55,1.34-0.9,2.1-0.92
				c0.79-0.02,1.53,0.21,2.22,0.8c0.59,0.5,1.07,1.13,1.38,1.97c0.35,0.92-0.14,2.27-1.11,2.17c-0.31-0.03-0.58-0.2-0.78-0.54
				c-0.22-0.39-0.44-0.77-0.78-0.99c-0.59-0.38-1.15-0.35-1.69,0.12c-1.46,1.27-2.91,2.56-4.37,3.83c-0.61,0.52-0.89,1.61-0.72,2.48
				c0.26,1.37,1.19,2.14,2.19,1.69c0.39-0.18,0.74-0.56,1.1-0.86c0.6-0.51,1.2-1.02,1.78-1.56c0.28-0.26,0.46-0.02,0.65,0.15
				c0.35,0.31,0.73,0.53,1.13,0.69c0.15,0.06,0.31,0.08,0.45,0.17c0.09,0.06,0.21,0.21,0.21,0.33c0.01,0.14-0.06,0.34-0.15,0.42
				c-1.2,1.06-2.4,2.11-3.61,3.15C59.7,52.55,59,52.88,58.2,52.87z"/>
    </g>
  </g>
  <g>
    <g>
      <path className={style.st1} d="M91.03,22.15c-0.01-0.64-0.08-1.26-0.23-1.88c-0.27-1.09-0.74-1.98-1.42-2.66c-0.59-0.6-1.27-0.93-2.02-1.03
				c-0.81-0.1-1.58,0.12-2.27,0.66c-0.83,0.65-1.62,1.38-2.43,2.08c-0.45,0.39-0.91,0.79-1.35,1.2c-0.08,0.08-0.14,0.27-0.14,0.41
				c0,0.16,0.08,0.29,0.23,0.34c0.21,0.06,0.42,0.13,0.62,0.25c0.38,0.24,0.74,0.51,1.11,0.77c0.17,0.12,0.32,0.13,0.49-0.03
				c0.79-0.71,1.59-1.39,2.38-2.09c0.28-0.25,0.57-0.4,0.91-0.43c0.86-0.08,1.68,0.82,1.77,2.01c0.09,1.05-0.23,1.86-0.89,2.44
				c-0.68,0.59-1.36,1.18-2.03,1.76c-0.8,0.68-1.59,1.38-2.39,2.04c-0.67,0.55-1.65,0.16-2.07-0.67c-0.17-0.34-0.37-0.63-0.65-0.78
				c-0.41-0.22-0.96-0.05-1.21,0.33c-0.39,0.6-0.42,1.27-0.22,1.83c0.21,0.59,0.55,1.07,0.92,1.47c0.54,0.59,1.15,0.97,1.86,1.13
				c0.78,0.17,1.52,0.09,2.23-0.35c0.49-0.31,0.94-0.72,1.39-1.11c1.01-0.87,2.01-1.75,3.02-2.63c0.67-0.58,1.3-1.19,1.73-2.13
				C90.8,24.17,91.01,23.2,91.03,22.15z M80.48,22.32c-0.52-0.01-1.01,0.13-1.49,0.37c-0.69,0.35-1.26,0.97-1.88,1.5
				c-0.91,0.77-1.8,1.57-2.7,2.36c-0.47,0.41-0.93,0.83-1.3,1.41c-0.35,0.55-0.61,1.17-0.79,1.86c-0.35,1.39-0.31,2.76,0.13,4.09
				c0.51,1.53,1.36,2.57,2.57,3.04c1.13,0.44,2.21,0.21,3.2-0.63c1.2-1.02,2.38-2.06,3.56-3.11c0.09-0.08,0.15-0.3,0.15-0.44
				c-0.01-0.11-0.13-0.26-0.22-0.32c-0.14-0.09-0.31-0.09-0.45-0.17c-0.37-0.22-0.74-0.45-1.11-0.69c-0.22-0.14-0.4-0.39-0.67-0.14
				c-0.59,0.54-1.18,1.06-1.78,1.57c-0.35,0.3-0.69,0.68-1.08,0.85c-1.08,0.49-2.1-0.48-2.23-1.96c-0.08-0.92,0.17-1.71,0.78-2.24
				c0.23-0.2,0.46-0.41,0.69-0.61c1.21-1.06,2.42-2.12,3.62-3.18c0.55-0.48,1.11-0.52,1.71-0.14c0.35,0.22,0.56,0.6,0.78,0.98
				c0.2,0.35,0.48,0.52,0.8,0.55c0.95,0.09,1.44-1.24,1.1-2.17c-0.31-0.84-0.79-1.47-1.38-1.97C81.88,22.59,81.21,22.35,80.48,22.32
				z"/>
      <path className={style.st1} d="M91.03,22.15c-0.03,1.05-0.24,2.02-0.65,2.93c-0.43,0.94-1.07,1.55-1.73,2.13
				c-1.01,0.87-2.01,1.76-3.02,2.63c-0.46,0.39-0.91,0.81-1.39,1.11c-0.7,0.44-1.45,0.52-2.23,0.35c-0.7-0.15-1.32-0.53-1.86-1.13
				c-0.37-0.41-0.7-0.88-0.92-1.47c-0.2-0.56-0.18-1.23,0.22-1.83c0.25-0.39,0.8-0.55,1.21-0.33c0.28,0.15,0.49,0.44,0.65,0.78
				c0.41,0.83,1.4,1.22,2.07,0.67c0.81-0.66,1.6-1.36,2.39-2.04c0.68-0.58,1.36-1.18,2.03-1.76c0.66-0.57,0.98-1.38,0.89-2.44
				c-0.1-1.19-0.91-2.09-1.77-2.01c-0.34,0.03-0.63,0.18-0.91,0.43c-0.79,0.7-1.59,1.38-2.38,2.09c-0.18,0.16-0.32,0.15-0.49,0.03
				c-0.37-0.26-0.73-0.53-1.11-0.77c-0.19-0.12-0.41-0.19-0.62-0.25c-0.15-0.04-0.23-0.17-0.23-0.34c0-0.14,0.06-0.33,0.14-0.41
				c0.44-0.42,0.89-0.81,1.35-1.2c0.81-0.7,1.6-1.43,2.43-2.08c0.69-0.55,1.45-0.76,2.27-0.66c0.75,0.09,1.42,0.43,2.02,1.03
				c0.68,0.68,1.15,1.57,1.42,2.66C90.95,20.88,91.02,21.51,91.03,22.15z"/>
      <path className={style.st1} d="M80.48,22.32c0.73,0.03,1.4,0.27,2.03,0.8c0.59,0.5,1.07,1.14,1.38,1.97c0.34,0.93-0.15,2.25-1.1,2.17
				c-0.32-0.03-0.59-0.2-0.8-0.55c-0.22-0.39-0.44-0.77-0.78-0.98c-0.6-0.38-1.16-0.34-1.71,0.14c-1.21,1.06-2.42,2.12-3.62,3.18
				c-0.23,0.2-0.46,0.41-0.69,0.61c-0.61,0.53-0.86,1.32-0.78,2.24c0.13,1.49,1.14,2.45,2.23,1.96c0.39-0.18,0.73-0.55,1.08-0.85
				c0.6-0.51,1.19-1.03,1.78-1.57c0.28-0.25,0.46,0,0.67,0.14c0.36,0.24,0.73,0.47,1.11,0.69c0.14,0.08,0.31,0.08,0.45,0.17
				c0.09,0.06,0.21,0.2,0.22,0.32c0.01,0.15-0.06,0.36-0.15,0.44c-1.18,1.05-2.36,2.1-3.56,3.11c-0.99,0.84-2.07,1.07-3.2,0.63
				c-1.21-0.47-2.06-1.5-2.57-3.04c-0.44-1.34-0.49-2.7-0.13-4.09c0.17-0.69,0.44-1.31,0.79-1.86c0.37-0.58,0.83-1,1.3-1.41
				c0.9-0.78,1.8-1.58,2.7-2.36c0.61-0.52,1.18-1.14,1.88-1.5C79.48,22.44,79.97,22.3,80.48,22.32z"/>
    </g>
  </g>
  <g>
    <g>
      <path className={style.st1} d="M36.32,63.16c0.02,0.63,0.08,1.24,0.23,1.85c0.27,1.09,0.74,1.98,1.42,2.66c0.59,0.59,1.27,0.94,2.02,1.03
				c0.82,0.1,1.59-0.11,2.28-0.67c0.87-0.7,1.71-1.46,2.56-2.19c0.4-0.35,0.81-0.69,1.2-1.07c0.08-0.08,0.15-0.27,0.15-0.41
				c0-0.17-0.09-0.29-0.24-0.35c-0.61-0.21-1.2-0.5-1.71-1c-0.14-0.13-0.29-0.17-0.46-0.02c-0.81,0.72-1.65,1.41-2.45,2.15
				c-0.72,0.67-1.77,0.48-2.31-0.47c-0.43-0.76-0.48-1.58-0.21-2.45c0.18-0.57,0.52-0.9,0.89-1.22c1.33-1.15,2.65-2.31,3.97-3.48
				c0.41-0.36,0.85-0.56,1.35-0.41c0.44,0.13,0.79,0.42,1.05,0.93c0.1,0.21,0.23,0.42,0.39,0.55c0.47,0.38,0.91,0.36,1.31-0.03
				c0.38-0.37,0.57-1.02,0.41-1.71c-0.17-0.73-0.57-1.25-0.98-1.72c-0.53-0.61-1.15-0.98-1.85-1.13c-0.75-0.16-1.48-0.12-2.17,0.32
				c-0.5,0.32-0.98,0.73-1.45,1.13c-1.01,0.86-2.01,1.75-3.02,2.62c-0.67,0.58-1.3,1.19-1.74,2.13
				C36.56,61.12,36.35,62.1,36.32,63.16z M46.88,62.97c0.06,0.01,0.13,0.03,0.19,0.02c0.76-0.06,1.46-0.38,2.1-0.93
				c1.34-1.17,2.68-2.36,4.02-3.52c0.9-0.78,1.57-1.82,1.88-3.2c0.33-1.47,0.24-2.9-0.3-4.28c-0.51-1.29-1.27-2.2-2.3-2.64
				c-1.21-0.52-2.37-0.29-3.44,0.65c-1.15,1.01-2.31,2.01-3.46,3.01c-0.14,0.12-0.2,0.28-0.17,0.49c0.03,0.21,0.16,0.26,0.29,0.31
				c0.6,0.2,1.18,0.5,1.68,0.99c0.13,0.13,0.27,0.16,0.42,0.04c0.15-0.13,0.3-0.26,0.45-0.39c0.77-0.66,1.53-1.34,2.31-1.98
				c0.52-0.43,1.3-0.24,1.73,0.23c0.53,0.59,0.78,1.36,0.66,2.28c-0.07,0.58-0.26,1.09-0.62,1.44c-0.27,0.26-0.56,0.5-0.84,0.75
				c-1.21,1.06-2.42,2.12-3.62,3.18c-0.55,0.48-1.11,0.52-1.71,0.14c-0.35-0.22-0.56-0.6-0.78-0.98c-0.2-0.34-0.47-0.51-0.78-0.55
				c-0.97-0.1-1.46,1.24-1.12,2.16c0.31,0.84,0.79,1.47,1.38,1.97C45.48,62.71,46.15,62.95,46.88,62.97z"/>
      <path className={style.st1} d="M36.32,63.16c0.02-1.06,0.24-2.04,0.66-2.95c0.43-0.94,1.07-1.55,1.74-2.13c1.01-0.87,2.01-1.76,3.02-2.62
				c0.47-0.4,0.95-0.81,1.45-1.13c0.69-0.44,1.42-0.48,2.17-0.32c0.7,0.15,1.32,0.52,1.85,1.13c0.41,0.47,0.81,0.99,0.98,1.72
				c0.16,0.69-0.03,1.34-0.41,1.71c-0.4,0.39-0.85,0.41-1.31,0.03c-0.16-0.13-0.29-0.34-0.39-0.55c-0.25-0.51-0.61-0.8-1.05-0.93
				c-0.5-0.15-0.94,0.05-1.35,0.41c-1.32,1.16-2.64,2.33-3.97,3.48c-0.37,0.32-0.71,0.65-0.89,1.22c-0.27,0.88-0.22,1.7,0.21,2.45
				c0.53,0.95,1.58,1.15,2.31,0.47c0.8-0.75,1.63-1.43,2.45-2.15c0.17-0.15,0.32-0.11,0.46,0.02c0.52,0.5,1.1,0.8,1.71,1
				c0.16,0.05,0.25,0.18,0.24,0.35c0,0.14-0.06,0.33-0.15,0.41c-0.39,0.37-0.8,0.72-1.2,1.07c-0.85,0.74-1.69,1.5-2.56,2.19
				c-0.69,0.56-1.46,0.77-2.28,0.67c-0.75-0.09-1.42-0.44-2.02-1.03c-0.68-0.68-1.15-1.57-1.42-2.66
				C36.4,64.41,36.34,63.79,36.32,63.16z"/>
      <path className={style.st1} d="M46.88,62.97c-0.73-0.02-1.4-0.26-2.03-0.79c-0.59-0.5-1.07-1.13-1.38-1.97c-0.35-0.93,0.15-2.27,1.12-2.16
				c0.31,0.03,0.58,0.2,0.78,0.55c0.22,0.39,0.44,0.77,0.78,0.98c0.6,0.38,1.16,0.34,1.71-0.14c1.21-1.06,2.42-2.12,3.62-3.18
				c0.28-0.25,0.57-0.49,0.84-0.75c0.37-0.35,0.55-0.87,0.62-1.44c0.11-0.93-0.13-1.7-0.66-2.28c-0.43-0.47-1.2-0.66-1.73-0.23
				c-0.78,0.64-1.54,1.32-2.31,1.98c-0.15,0.13-0.3,0.26-0.45,0.39c-0.15,0.13-0.29,0.09-0.42-0.04c-0.51-0.49-1.08-0.79-1.68-0.99
				c-0.13-0.04-0.26-0.09-0.29-0.31c-0.03-0.21,0.03-0.37,0.17-0.49c1.15-1,2.31-2,3.46-3.01c1.07-0.94,2.23-1.18,3.44-0.65
				c1.03,0.44,1.8,1.35,2.3,2.64c0.54,1.38,0.63,2.81,0.3,4.28c-0.31,1.38-0.98,2.42-1.88,3.2c-1.35,1.16-2.68,2.35-4.02,3.52
				c-0.64,0.55-1.34,0.87-2.1,0.93C47.01,62.99,46.94,62.98,46.88,62.97z"/>
    </g>
  </g>
  <g>
    <g>
      <path className={style.st1} d="M18.3,78.82c0.02,0.63,0.08,1.24,0.23,1.85c0.27,1.09,0.74,1.98,1.42,2.66c0.59,0.59,1.27,0.94,2.02,1.03
				c0.82,0.1,1.59-0.11,2.28-0.67c0.87-0.7,1.71-1.46,2.56-2.19c0.4-0.35,0.81-0.69,1.2-1.07c0.08-0.08,0.15-0.27,0.15-0.41
				c0-0.17-0.09-0.29-0.24-0.35c-0.61-0.21-1.2-0.5-1.71-1c-0.14-0.13-0.29-0.17-0.46-0.02c-0.81,0.72-1.65,1.41-2.45,2.15
				c-0.72,0.67-1.77,0.48-2.31-0.47c-0.43-0.76-0.48-1.58-0.21-2.45c0.18-0.57,0.52-0.9,0.89-1.22c1.33-1.15,2.65-2.31,3.97-3.48
				c0.41-0.36,0.85-0.56,1.35-0.41c0.44,0.13,0.79,0.42,1.05,0.93c0.1,0.21,0.23,0.42,0.39,0.55c0.47,0.38,0.91,0.36,1.31-0.03
				c0.38-0.37,0.57-1.02,0.41-1.71c-0.17-0.73-0.57-1.25-0.98-1.72c-0.53-0.61-1.15-0.98-1.85-1.13c-0.75-0.16-1.48-0.12-2.17,0.32
				c-0.5,0.32-0.98,0.73-1.45,1.13c-1.01,0.86-2.01,1.75-3.02,2.62c-0.67,0.58-1.3,1.19-1.74,2.13
				C18.54,76.78,18.33,77.76,18.3,78.82z M28.86,78.62c0.06,0.01,0.13,0.03,0.19,0.02c0.76-0.06,1.46-0.38,2.1-0.93
				c1.34-1.17,2.68-2.36,4.02-3.52c0.9-0.78,1.57-1.82,1.88-3.2c0.33-1.47,0.24-2.9-0.3-4.28c-0.51-1.29-1.27-2.2-2.3-2.64
				c-1.21-0.52-2.37-0.29-3.44,0.65c-1.15,1.01-2.31,2.01-3.46,3.01c-0.14,0.12-0.2,0.28-0.17,0.49c0.03,0.21,0.16,0.26,0.29,0.31
				c0.6,0.2,1.18,0.5,1.68,0.99c0.13,0.13,0.27,0.16,0.42,0.04c0.15-0.13,0.3-0.26,0.45-0.39c0.77-0.66,1.53-1.34,2.31-1.98
				c0.52-0.43,1.3-0.24,1.73,0.23c0.53,0.59,0.78,1.36,0.66,2.28c-0.07,0.58-0.26,1.09-0.62,1.44c-0.27,0.26-0.56,0.5-0.84,0.75
				c-1.21,1.06-2.42,2.12-3.62,3.18c-0.55,0.48-1.11,0.52-1.71,0.14c-0.35-0.22-0.56-0.6-0.78-0.98c-0.2-0.34-0.47-0.51-0.78-0.55
				c-0.97-0.1-1.46,1.24-1.12,2.16c0.31,0.84,0.79,1.47,1.38,1.97C27.46,78.36,28.13,78.6,28.86,78.62z"/>
      <path className={style.st1} d="M18.3,78.82c0.02-1.06,0.24-2.04,0.66-2.95c0.43-0.94,1.07-1.55,1.74-2.13c1.01-0.87,2.01-1.76,3.02-2.62
				c0.47-0.4,0.95-0.81,1.45-1.13c0.69-0.44,1.42-0.48,2.17-0.32c0.7,0.15,1.32,0.52,1.85,1.13c0.41,0.47,0.81,0.99,0.98,1.72
				c0.16,0.69-0.03,1.34-0.41,1.71c-0.4,0.39-0.85,0.41-1.31,0.03c-0.16-0.13-0.29-0.34-0.39-0.55c-0.25-0.51-0.61-0.8-1.05-0.93
				c-0.5-0.15-0.94,0.05-1.35,0.41c-1.32,1.16-2.64,2.33-3.97,3.48c-0.37,0.32-0.71,0.65-0.89,1.22c-0.27,0.88-0.22,1.7,0.21,2.45
				c0.53,0.95,1.58,1.15,2.31,0.47c0.8-0.75,1.63-1.43,2.45-2.15c0.17-0.15,0.32-0.11,0.46,0.02c0.52,0.5,1.1,0.8,1.71,1
				c0.16,0.05,0.25,0.18,0.24,0.35c0,0.14-0.06,0.33-0.15,0.41c-0.39,0.37-0.8,0.72-1.2,1.07c-0.85,0.74-1.69,1.5-2.56,2.19
				c-0.69,0.56-1.46,0.77-2.28,0.67c-0.75-0.09-1.42-0.44-2.02-1.03c-0.68-0.68-1.15-1.57-1.42-2.66
				C18.38,80.06,18.32,79.45,18.3,78.82z"/>
      <path className={style.st1} d="M28.86,78.62c-0.73-0.02-1.4-0.26-2.03-0.79c-0.59-0.5-1.07-1.13-1.38-1.97c-0.35-0.93,0.15-2.27,1.12-2.16
				c0.31,0.03,0.58,0.2,0.78,0.55c0.22,0.39,0.44,0.77,0.78,0.98c0.6,0.38,1.16,0.34,1.71-0.14c1.21-1.06,2.42-2.12,3.62-3.18
				c0.28-0.25,0.57-0.49,0.84-0.75c0.37-0.35,0.55-0.87,0.62-1.44c0.11-0.93-0.13-1.7-0.66-2.28c-0.43-0.47-1.2-0.66-1.73-0.23
				c-0.78,0.64-1.54,1.32-2.31,1.98c-0.15,0.13-0.3,0.26-0.45,0.39c-0.15,0.13-0.29,0.09-0.42-0.04c-0.51-0.49-1.08-0.79-1.68-0.99
				c-0.13-0.04-0.26-0.09-0.29-0.31c-0.03-0.21,0.03-0.37,0.17-0.49c1.15-1,2.31-2,3.46-3.01c1.07-0.94,2.23-1.18,3.44-0.65
				c1.03,0.44,1.8,1.35,2.3,2.64c0.54,1.38,0.63,2.81,0.3,4.28c-0.31,1.38-0.98,2.42-1.88,3.2c-1.35,1.16-2.68,2.35-4.02,3.52
				c-0.64,0.55-1.34,0.87-2.1,0.93C28.99,78.65,28.92,78.63,28.86,78.62z"/>
    </g>
  </g>
  <rect x="18.3" y="77.59" width="72.73" height="7.3"/>
</g>
<g>
  <g>
    <g>
      <path className={style.st0} d="M109.62,40.82c0.43,0.94,1.07,1.55,1.73,2.13c1.01,0.87,2.01,1.75,3.02,2.62c0.46,0.39,0.91,0.81,1.39,1.11
				c0.7,0.44,1.45,0.52,2.23,0.35c0.7-0.15,1.32-0.53,1.86-1.12c0.37-0.41,0.7-0.88,0.92-1.47c0.2-0.55,0.18-1.23-0.22-1.82
				c-0.25-0.39-0.8-0.55-1.21-0.33c-0.28,0.15-0.49,0.44-0.65,0.78c-0.41,0.83-1.4,1.22-2.07,0.67c-0.81-0.66-1.6-1.35-2.39-2.04
				c-0.68-0.58-1.36-1.17-2.03-1.76c-0.66-0.57-0.98-1.38-0.89-2.43c0.1-1.18,0.91-2.08,1.77-2c0.34,0.03,0.63,0.18,0.91,0.43
				c0.79,0.7,1.59,1.38,2.38,2.09c0.18,0.16,0.32,0.15,0.49,0.03c0.37-0.26,0.73-0.53,1.11-0.76c0.19-0.12,0.41-0.19,0.62-0.25
				c0.15-0.04,0.23-0.17,0.23-0.34c0-0.14-0.06-0.33-0.14-0.41c-0.44-0.42-0.89-0.81-1.35-1.2c-0.81-0.7-1.6-1.42-2.43-2.08
				c-0.69-0.54-1.45-0.76-2.27-0.66c-0.75,0.09-1.42,0.43-2.02,1.03c-0.68,0.68-1.15,1.56-1.42,2.66c-0.15,0.62-0.22,1.24-0.23,1.88
				C108.99,38.95,109.2,39.92,109.62,40.82z M126.04,52.01c0.77-0.65,1.29-1.58,1.6-2.68c0.3-1.03,0.34-2.11,0.16-3.2
				c-0.12-0.75-0.36-1.44-0.69-2.06c-0.37-0.7-0.87-1.22-1.41-1.68c-1.3-1.13-2.59-2.27-3.89-3.4c-0.64-0.55-1.34-0.9-2.1-0.92
				c-0.79-0.02-1.53,0.21-2.22,0.8c-0.59,0.5-1.07,1.13-1.38,1.97c-0.35,0.92,0.14,2.27,1.11,2.17c0.31-0.03,0.58-0.2,0.78-0.54
				c0.22-0.39,0.44-0.77,0.78-0.99c0.59-0.38,1.15-0.35,1.69,0.12c1.46,1.27,2.91,2.56,4.37,3.83c0.61,0.52,0.89,1.61,0.72,2.48
				c-0.26,1.37-1.19,2.14-2.19,1.69c-0.39-0.18-0.74-0.56-1.1-0.86c-0.6-0.51-1.2-1.02-1.78-1.56c-0.28-0.26-0.46-0.02-0.65,0.15
				c-0.35,0.31-0.73,0.53-1.13,0.69c-0.15,0.06-0.31,0.08-0.45,0.17c-0.09,0.06-0.21,0.21-0.21,0.33c-0.01,0.14,0.06,0.34,0.15,0.42
				c1.2,1.06,2.4,2.11,3.61,3.15c0.56,0.48,1.27,0.81,2.06,0.8C124.65,52.87,125.37,52.59,126.04,52.01z"/>
      <path className={style.st0} d="M108.96,37.9c0.03,1.05,0.24,2.02,0.65,2.93c0.43,0.94,1.07,1.55,1.73,2.13c1.01,0.87,2.01,1.75,3.02,2.62
				c0.46,0.39,0.91,0.81,1.39,1.11c0.7,0.44,1.45,0.52,2.23,0.35c0.7-0.15,1.32-0.53,1.86-1.12c0.37-0.41,0.7-0.88,0.92-1.47
				c0.2-0.55,0.18-1.23-0.22-1.82c-0.25-0.39-0.8-0.55-1.21-0.33c-0.28,0.15-0.49,0.44-0.65,0.78c-0.41,0.83-1.4,1.22-2.07,0.67
				c-0.81-0.66-1.6-1.35-2.39-2.04c-0.68-0.58-1.36-1.17-2.03-1.76c-0.66-0.57-0.98-1.38-0.89-2.43c0.1-1.18,0.91-2.08,1.77-2
				c0.34,0.03,0.63,0.18,0.91,0.43c0.79,0.7,1.59,1.38,2.38,2.09c0.18,0.16,0.32,0.15,0.49,0.03c0.37-0.26,0.73-0.53,1.11-0.76
				c0.19-0.12,0.41-0.19,0.62-0.25c0.15-0.04,0.23-0.17,0.23-0.34c0-0.14-0.06-0.33-0.14-0.41c-0.44-0.42-0.89-0.81-1.35-1.2
				c-0.81-0.7-1.6-1.42-2.43-2.08c-0.69-0.54-1.45-0.76-2.27-0.66c-0.75,0.09-1.42,0.43-2.02,1.03c-0.68,0.68-1.15,1.56-1.42,2.66
				C109.04,36.64,108.98,37.26,108.96,37.9z"/>
      <path className={style.st0} d="M123.86,52.87c0.79,0,1.51-0.28,2.17-0.85c0.77-0.65,1.29-1.58,1.6-2.68c0.3-1.03,0.34-2.11,0.16-3.2
				c-0.12-0.75-0.36-1.44-0.69-2.06c-0.37-0.7-0.87-1.22-1.41-1.68c-1.3-1.13-2.59-2.27-3.89-3.4c-0.64-0.55-1.34-0.9-2.1-0.92
				c-0.79-0.02-1.53,0.21-2.22,0.8c-0.59,0.5-1.07,1.13-1.38,1.97c-0.35,0.92,0.14,2.27,1.11,2.17c0.31-0.03,0.58-0.2,0.78-0.54
				c0.22-0.39,0.44-0.77,0.78-0.99c0.59-0.38,1.15-0.35,1.69,0.12c1.46,1.27,2.91,2.56,4.37,3.83c0.61,0.52,0.89,1.61,0.72,2.48
				c-0.26,1.37-1.19,2.14-2.19,1.69c-0.39-0.18-0.74-0.56-1.1-0.86c-0.6-0.51-1.2-1.02-1.78-1.56c-0.28-0.26-0.46-0.02-0.65,0.15
				c-0.35,0.31-0.73,0.53-1.13,0.69c-0.15,0.06-0.31,0.08-0.45,0.17c-0.09,0.06-0.21,0.21-0.21,0.33c-0.01,0.14,0.06,0.34,0.15,0.42
				c1.2,1.06,2.4,2.11,3.61,3.15C122.37,52.55,123.07,52.88,123.86,52.87z"/>
    </g>
  </g>
  <g>
    <g>
      <path className={style.st1} d="M91.69,25.08c0.43,0.94,1.07,1.55,1.73,2.13c1.01,0.87,2.01,1.76,3.02,2.63c0.46,0.39,0.91,0.81,1.39,1.11
				c0.7,0.44,1.45,0.52,2.23,0.35c0.7-0.15,1.32-0.53,1.86-1.13c0.37-0.41,0.7-0.88,0.92-1.47c0.2-0.56,0.18-1.23-0.22-1.83
				c-0.25-0.39-0.8-0.55-1.21-0.33c-0.28,0.15-0.49,0.44-0.65,0.78c-0.41,0.83-1.4,1.22-2.07,0.67c-0.81-0.66-1.6-1.36-2.39-2.04
				c-0.68-0.58-1.36-1.18-2.03-1.76c-0.66-0.57-0.98-1.38-0.89-2.44c0.1-1.19,0.91-2.09,1.77-2.01c0.34,0.03,0.63,0.18,0.91,0.43
				c0.79,0.7,1.59,1.38,2.38,2.09c0.18,0.16,0.32,0.15,0.49,0.03c0.37-0.26,0.73-0.53,1.11-0.77c0.19-0.12,0.41-0.19,0.62-0.25
				c0.15-0.04,0.23-0.17,0.23-0.34c0-0.14-0.06-0.33-0.14-0.41c-0.44-0.42-0.89-0.81-1.35-1.2c-0.81-0.7-1.6-1.43-2.43-2.08
				c-0.69-0.55-1.45-0.76-2.27-0.66c-0.75,0.09-1.42,0.43-2.02,1.03c-0.68,0.68-1.15,1.57-1.42,2.66c-0.15,0.62-0.22,1.24-0.23,1.88
				C91.06,23.2,91.27,24.17,91.69,25.08z M99.56,23.12c-0.59,0.5-1.07,1.14-1.38,1.97c-0.34,0.93,0.15,2.25,1.1,2.17
				c0.32-0.03,0.59-0.2,0.8-0.55c0.22-0.39,0.44-0.77,0.78-0.98c0.6-0.38,1.16-0.34,1.71,0.14c1.21,1.06,2.42,2.12,3.62,3.18
				c0.23,0.2,0.46,0.41,0.69,0.61c0.61,0.53,0.86,1.32,0.78,2.24c-0.13,1.49-1.14,2.45-2.23,1.96c-0.39-0.18-0.73-0.55-1.08-0.85
				c-0.6-0.51-1.19-1.03-1.78-1.57c-0.28-0.25-0.46,0-0.67,0.14c-0.36,0.24-0.73,0.47-1.11,0.69c-0.14,0.08-0.31,0.08-0.45,0.17
				c-0.09,0.06-0.21,0.2-0.22,0.32c-0.01,0.15,0.06,0.36,0.15,0.44c1.18,1.05,2.36,2.1,3.56,3.11c0.99,0.84,2.07,1.07,3.2,0.63
				c1.21-0.47,2.06-1.5,2.57-3.04c0.44-1.34,0.49-2.7,0.13-4.09c-0.17-0.69-0.44-1.31-0.79-1.86c-0.37-0.58-0.83-1-1.3-1.41
				c-0.9-0.78-1.8-1.58-2.7-2.36c-0.61-0.52-1.18-1.14-1.88-1.5c-0.48-0.25-0.97-0.39-1.49-0.37
				C100.86,22.35,100.18,22.59,99.56,23.12z"/>
      <path className={style.st1} d="M91.03,22.15c0.03,1.05,0.24,2.02,0.65,2.93c0.43,0.94,1.07,1.55,1.73,2.13c1.01,0.87,2.01,1.76,3.02,2.63
				c0.46,0.39,0.91,0.81,1.39,1.11c0.7,0.44,1.45,0.52,2.23,0.35c0.7-0.15,1.32-0.53,1.86-1.13c0.37-0.41,0.7-0.88,0.92-1.47
				c0.2-0.56,0.18-1.23-0.22-1.83c-0.25-0.39-0.8-0.55-1.21-0.33c-0.28,0.15-0.49,0.44-0.65,0.78c-0.41,0.83-1.4,1.22-2.07,0.67
				c-0.81-0.66-1.6-1.36-2.39-2.04c-0.68-0.58-1.36-1.18-2.03-1.76c-0.66-0.57-0.98-1.38-0.89-2.44c0.1-1.19,0.91-2.09,1.77-2.01
				c0.34,0.03,0.63,0.18,0.91,0.43c0.79,0.7,1.59,1.38,2.38,2.09c0.18,0.16,0.32,0.15,0.49,0.03c0.37-0.26,0.73-0.53,1.11-0.77
				c0.19-0.12,0.41-0.19,0.62-0.25c0.15-0.04,0.23-0.17,0.23-0.34c0-0.14-0.06-0.33-0.14-0.41c-0.44-0.42-0.89-0.81-1.35-1.2
				c-0.81-0.7-1.6-1.43-2.43-2.08c-0.69-0.55-1.45-0.76-2.27-0.66c-0.75,0.09-1.42,0.43-2.02,1.03c-0.68,0.68-1.15,1.57-1.42,2.66
				C91.12,20.88,91.05,21.51,91.03,22.15z"/>
      <path className={style.st1} d="M101.59,22.32c-0.73,0.03-1.4,0.27-2.03,0.8c-0.59,0.5-1.07,1.14-1.38,1.97c-0.34,0.93,0.15,2.25,1.1,2.17
				c0.32-0.03,0.59-0.2,0.8-0.55c0.22-0.39,0.44-0.77,0.78-0.98c0.6-0.38,1.16-0.34,1.71,0.14c1.21,1.06,2.42,2.12,3.62,3.18
				c0.23,0.2,0.46,0.41,0.69,0.61c0.61,0.53,0.86,1.32,0.78,2.24c-0.13,1.49-1.14,2.45-2.23,1.96c-0.39-0.18-0.73-0.55-1.08-0.85
				c-0.6-0.51-1.19-1.03-1.78-1.57c-0.28-0.25-0.46,0-0.67,0.14c-0.36,0.24-0.73,0.47-1.11,0.69c-0.14,0.08-0.31,0.08-0.45,0.17
				c-0.09,0.06-0.21,0.2-0.22,0.32c-0.01,0.15,0.06,0.36,0.15,0.44c1.18,1.05,2.36,2.1,3.56,3.11c0.99,0.84,2.07,1.07,3.2,0.63
				c1.21-0.47,2.06-1.5,2.57-3.04c0.44-1.34,0.49-2.7,0.13-4.09c-0.17-0.69-0.44-1.31-0.79-1.86c-0.37-0.58-0.83-1-1.3-1.41
				c-0.9-0.78-1.8-1.58-2.7-2.36c-0.61-0.52-1.18-1.14-1.88-1.5C102.59,22.44,102.1,22.3,101.59,22.32z"/>
    </g>
  </g>
  <g>
    <g>
      <path className={style.st1} d="M145.09,60.21c-0.43-0.94-1.07-1.55-1.74-2.13c-1.01-0.87-2.01-1.76-3.02-2.62
				c-0.47-0.4-0.95-0.81-1.45-1.13c-0.69-0.44-1.42-0.48-2.17-0.32c-0.7,0.15-1.32,0.52-1.85,1.13c-0.41,0.47-0.81,0.99-0.98,1.72
				c-0.16,0.69,0.03,1.34,0.41,1.71c0.4,0.39,0.85,0.41,1.31,0.03c0.16-0.13,0.29-0.34,0.39-0.55c0.25-0.51,0.61-0.8,1.05-0.93
				c0.5-0.15,0.94,0.05,1.35,0.41c1.32,1.16,2.64,2.33,3.97,3.48c0.37,0.32,0.71,0.65,0.89,1.22c0.27,0.88,0.22,1.7-0.21,2.45
				c-0.53,0.95-1.58,1.15-2.31,0.47c-0.8-0.75-1.63-1.43-2.45-2.15c-0.17-0.15-0.32-0.11-0.46,0.02c-0.52,0.5-1.1,0.8-1.71,1
				c-0.16,0.05-0.25,0.18-0.24,0.35c0,0.14,0.06,0.33,0.15,0.41c0.39,0.37,0.8,0.72,1.2,1.07c0.85,0.74,1.69,1.5,2.56,2.19
				c0.69,0.56,1.46,0.77,2.28,0.67c0.75-0.09,1.42-0.44,2.02-1.03c0.68-0.68,1.15-1.57,1.42-2.66c0.15-0.61,0.21-1.22,0.23-1.85
				C145.72,62.1,145.51,61.12,145.09,60.21z M137.22,62.18c0.59-0.5,1.07-1.13,1.38-1.97c0.35-0.93-0.15-2.27-1.12-2.16
				c-0.31,0.03-0.58,0.2-0.78,0.55c-0.22,0.39-0.44,0.77-0.78,0.98c-0.6,0.38-1.16,0.34-1.71-0.14c-1.21-1.06-2.42-2.12-3.62-3.18
				c-0.28-0.25-0.57-0.49-0.84-0.75c-0.37-0.35-0.55-0.87-0.62-1.44c-0.11-0.93,0.13-1.7,0.66-2.28c0.43-0.47,1.2-0.66,1.73-0.23
				c0.78,0.64,1.54,1.32,2.31,1.98c0.15,0.13,0.3,0.26,0.45,0.39c0.15,0.13,0.29,0.09,0.42-0.04c0.51-0.49,1.08-0.79,1.68-0.99
				c0.13-0.04,0.26-0.09,0.29-0.31c0.03-0.21-0.03-0.37-0.17-0.49c-1.15-1-2.31-2-3.46-3.01c-1.07-0.94-2.23-1.18-3.44-0.65
				c-1.03,0.44-1.8,1.35-2.3,2.64c-0.54,1.38-0.63,2.81-0.3,4.28c0.31,1.38,0.98,2.42,1.88,3.2c1.35,1.16,2.68,2.35,4.02,3.52
				c0.64,0.55,1.34,0.87,2.1,0.93c0.06,0.01,0.13-0.01,0.19-0.02C135.92,62.95,136.59,62.71,137.22,62.18z"/>
      <path className={style.st1} d="M145.75,63.16c-0.02-1.06-0.24-2.04-0.66-2.95c-0.43-0.94-1.07-1.55-1.74-2.13
				c-1.01-0.87-2.01-1.76-3.02-2.62c-0.47-0.4-0.95-0.81-1.45-1.13c-0.69-0.44-1.42-0.48-2.17-0.32c-0.7,0.15-1.32,0.52-1.85,1.13
				c-0.41,0.47-0.81,0.99-0.98,1.72c-0.16,0.69,0.03,1.34,0.41,1.71c0.4,0.39,0.85,0.41,1.31,0.03c0.16-0.13,0.29-0.34,0.39-0.55
				c0.25-0.51,0.61-0.8,1.05-0.93c0.5-0.15,0.94,0.05,1.35,0.41c1.32,1.16,2.64,2.33,3.97,3.48c0.37,0.32,0.71,0.65,0.89,1.22
				c0.27,0.88,0.22,1.7-0.21,2.45c-0.53,0.95-1.58,1.15-2.31,0.47c-0.8-0.75-1.63-1.43-2.45-2.15c-0.17-0.15-0.32-0.11-0.46,0.02
				c-0.52,0.5-1.1,0.8-1.71,1c-0.16,0.05-0.25,0.18-0.24,0.35c0,0.14,0.06,0.33,0.15,0.41c0.39,0.37,0.8,0.72,1.2,1.07
				c0.85,0.74,1.69,1.5,2.56,2.19c0.69,0.56,1.46,0.77,2.28,0.67c0.75-0.09,1.42-0.44,2.02-1.03c0.68-0.68,1.15-1.57,1.42-2.66
				C145.66,64.41,145.73,63.79,145.75,63.16z"/>
      <path className={style.st1} d="M135.19,62.97c0.73-0.02,1.4-0.26,2.03-0.79c0.59-0.5,1.07-1.13,1.38-1.97c0.35-0.93-0.15-2.27-1.12-2.16
				c-0.31,0.03-0.58,0.2-0.78,0.55c-0.22,0.39-0.44,0.77-0.78,0.98c-0.6,0.38-1.16,0.34-1.71-0.14c-1.21-1.06-2.42-2.12-3.62-3.18
				c-0.28-0.25-0.57-0.49-0.84-0.75c-0.37-0.35-0.55-0.87-0.62-1.44c-0.11-0.93,0.13-1.7,0.66-2.28c0.43-0.47,1.2-0.66,1.73-0.23
				c0.78,0.64,1.54,1.32,2.31,1.98c0.15,0.13,0.3,0.26,0.45,0.39c0.15,0.13,0.29,0.09,0.42-0.04c0.51-0.49,1.08-0.79,1.68-0.99
				c0.13-0.04,0.26-0.09,0.29-0.31c0.03-0.21-0.03-0.37-0.17-0.49c-1.15-1-2.31-2-3.46-3.01c-1.07-0.94-2.23-1.18-3.44-0.65
				c-1.03,0.44-1.8,1.35-2.3,2.64c-0.54,1.38-0.63,2.81-0.3,4.28c0.31,1.38,0.98,2.42,1.88,3.2c1.35,1.16,2.68,2.35,4.02,3.52
				c0.64,0.55,1.34,0.87,2.1,0.93C135.06,62.99,135.13,62.98,135.19,62.97z"/>
    </g>
  </g>
  <g>
    <g>
      <path className={style.st1} d="M163.11,75.87c-0.43-0.94-1.07-1.55-1.74-2.13c-1.01-0.87-2.01-1.76-3.02-2.62
				c-0.47-0.4-0.95-0.81-1.45-1.13c-0.69-0.44-1.42-0.48-2.17-0.32c-0.7,0.15-1.32,0.52-1.85,1.13c-0.41,0.47-0.81,0.99-0.98,1.72
				c-0.16,0.69,0.03,1.34,0.41,1.71c0.4,0.39,0.85,0.41,1.31,0.03c0.16-0.13,0.29-0.34,0.39-0.55c0.25-0.51,0.61-0.8,1.05-0.93
				c0.5-0.15,0.94,0.05,1.35,0.41c1.32,1.16,2.64,2.33,3.97,3.48c0.37,0.32,0.71,0.65,0.89,1.22c0.27,0.88,0.22,1.7-0.21,2.45
				c-0.53,0.95-1.58,1.15-2.31,0.47c-0.8-0.75-1.63-1.43-2.45-2.15c-0.17-0.15-0.32-0.11-0.46,0.02c-0.52,0.5-1.1,0.8-1.71,1
				c-0.16,0.05-0.25,0.18-0.24,0.35c0,0.14,0.06,0.33,0.15,0.41c0.39,0.37,0.8,0.72,1.2,1.07c0.85,0.74,1.69,1.5,2.56,2.19
				c0.69,0.56,1.46,0.77,2.28,0.67c0.75-0.09,1.42-0.44,2.02-1.03c0.68-0.68,1.15-1.57,1.42-2.66c0.15-0.61,0.21-1.22,0.23-1.85
				C163.74,77.76,163.53,76.78,163.11,75.87z M155.24,77.83c0.59-0.5,1.07-1.13,1.38-1.97c0.35-0.93-0.15-2.27-1.12-2.16
				c-0.31,0.03-0.58,0.2-0.78,0.55c-0.22,0.39-0.44,0.77-0.78,0.98c-0.6,0.38-1.16,0.34-1.71-0.14c-1.21-1.06-2.42-2.12-3.62-3.18
				c-0.28-0.25-0.57-0.49-0.84-0.75c-0.37-0.35-0.55-0.87-0.62-1.44c-0.11-0.93,0.13-1.7,0.66-2.28c0.43-0.47,1.2-0.66,1.73-0.23
				c0.78,0.64,1.54,1.32,2.31,1.98c0.15,0.13,0.3,0.26,0.45,0.39c0.15,0.13,0.29,0.09,0.42-0.04c0.51-0.49,1.08-0.79,1.68-0.99
				c0.13-0.04,0.26-0.09,0.29-0.31c0.03-0.21-0.03-0.37-0.17-0.49c-1.15-1-2.31-2-3.46-3.01c-1.07-0.94-2.23-1.18-3.44-0.65
				c-1.03,0.44-1.8,1.35-2.3,2.64c-0.54,1.38-0.63,2.81-0.3,4.28c0.31,1.38,0.98,2.42,1.88,3.2c1.35,1.16,2.68,2.35,4.02,3.52
				c0.64,0.55,1.34,0.87,2.1,0.93c0.06,0.01,0.13-0.01,0.19-0.02C153.94,78.6,154.61,78.36,155.24,77.83z"/>
      <path className={style.st1} d="M163.77,78.82c-0.02-1.06-0.24-2.04-0.66-2.95c-0.43-0.94-1.07-1.55-1.74-2.13
				c-1.01-0.87-2.01-1.76-3.02-2.62c-0.47-0.4-0.95-0.81-1.45-1.13c-0.69-0.44-1.42-0.48-2.17-0.32c-0.7,0.15-1.32,0.52-1.85,1.13
				c-0.41,0.47-0.81,0.99-0.98,1.72c-0.16,0.69,0.03,1.34,0.41,1.71c0.4,0.39,0.85,0.41,1.31,0.03c0.16-0.13,0.29-0.34,0.39-0.55
				c0.25-0.51,0.61-0.8,1.05-0.93c0.5-0.15,0.94,0.05,1.35,0.41c1.32,1.16,2.64,2.33,3.97,3.48c0.37,0.32,0.71,0.65,0.89,1.22
				c0.27,0.88,0.22,1.7-0.21,2.45c-0.53,0.95-1.58,1.15-2.31,0.47c-0.8-0.75-1.63-1.43-2.45-2.15c-0.17-0.15-0.32-0.11-0.46,0.02
				c-0.52,0.5-1.1,0.8-1.71,1c-0.16,0.05-0.25,0.18-0.24,0.35c0,0.14,0.06,0.33,0.15,0.41c0.39,0.37,0.8,0.72,1.2,1.07
				c0.85,0.74,1.69,1.5,2.56,2.19c0.69,0.56,1.46,0.77,2.28,0.67c0.75-0.09,1.42-0.44,2.02-1.03c0.68-0.68,1.15-1.57,1.42-2.66
				C163.69,80.06,163.75,79.45,163.77,78.82z"/>
      <path className={style.st1} d="M153.21,78.62c0.73-0.02,1.4-0.26,2.03-0.79c0.59-0.5,1.07-1.13,1.38-1.97c0.35-0.93-0.15-2.27-1.12-2.16
				c-0.31,0.03-0.58,0.2-0.78,0.55c-0.22,0.39-0.44,0.77-0.78,0.98c-0.6,0.38-1.16,0.34-1.71-0.14c-1.21-1.06-2.42-2.12-3.62-3.18
				c-0.28-0.25-0.57-0.49-0.84-0.75c-0.37-0.35-0.55-0.87-0.62-1.44c-0.11-0.93,0.13-1.7,0.66-2.28c0.43-0.47,1.2-0.66,1.73-0.23
				c0.78,0.64,1.54,1.32,2.31,1.98c0.15,0.13,0.3,0.26,0.45,0.39c0.15,0.13,0.29,0.09,0.42-0.04c0.51-0.49,1.08-0.79,1.68-0.99
				c0.13-0.04,0.26-0.09,0.29-0.31c0.03-0.21-0.03-0.37-0.17-0.49c-1.15-1-2.31-2-3.46-3.01c-1.07-0.94-2.23-1.18-3.44-0.65
				c-1.03,0.44-1.8,1.35-2.3,2.64c-0.54,1.38-0.63,2.81-0.3,4.28c0.31,1.38,0.98,2.42,1.88,3.2c1.35,1.16,2.68,2.35,4.02,3.52
				c0.64,0.55,1.34,0.87,2.1,0.93C153.08,78.65,153.15,78.63,153.21,78.62z"/>
    </g>
  </g>
  <rect x="91.03" y="77.59" transform="matrix(-1 -6.142344e-11 6.142344e-11 -1 254.8009 162.4816)" width="72.73" height="7.3"/>
</g>
<path className={style.st0} d="M86.54,54.48c0,5.45,2.29,8.17,6.86,8.17c0.82,0,1.6-0.08,2.33-0.23c0.73-0.15,1.62-0.41,2.68-0.77
	c0.85,1.85,1.41,3.75,1.7,5.7c-0.74,0.28-1.44,0.51-2.08,0.69c-0.64,0.18-1.26,0.31-1.85,0.4c-0.59,0.09-1.18,0.15-1.75,0.19
	c-0.58,0.04-1.17,0.06-1.79,0.06c-2.18,0-4.11-0.35-5.76-1.06c-1.66-0.71-3.04-1.69-4.16-2.95c-1.12-1.26-1.96-2.76-2.52-4.51
	c-0.57-1.75-0.85-3.65-0.85-5.7c0-2.05,0.29-3.96,0.89-5.72c0.59-1.76,1.45-3.28,2.56-4.57c1.12-1.29,2.5-2.29,4.14-3.01
	c1.64-0.72,3.51-1.08,5.59-1.08c1.23,0,2.4,0.09,3.51,0.27c1.1,0.18,2.34,0.54,3.7,1.08c-0.05,1.05-0.24,2.08-0.58,3.06
	c-0.33,0.99-0.68,1.86-1.04,2.6c-0.52-0.18-0.98-0.33-1.41-0.46c-0.42-0.13-0.83-0.23-1.21-0.31c-0.38-0.08-0.77-0.14-1.16-0.17
	c-0.39-0.04-0.8-0.06-1.23-0.06c-2.08,0-3.69,0.7-4.84,2.1C87.11,49.62,86.54,51.7,86.54,54.48z"/>
</svg>
);

export const logoSmall: React.SVGProps<SVGSVGElement> = (
 <svg version="1.1" id="Warstwa_1" height={22} x="0px" y="0px"
viewBox="0 0 184.83 104.83">

<g>
  <g>
    <g>
      <path className={style.st0} d="M73.1,37.9c-0.01-0.64-0.08-1.26-0.23-1.88c-0.27-1.09-0.74-1.98-1.42-2.66c-0.59-0.59-1.27-0.93-2.02-1.03
				c-0.81-0.1-1.58,0.11-2.27,0.66c-0.83,0.65-1.62,1.38-2.43,2.08c-0.45,0.39-0.91,0.78-1.35,1.2c-0.08,0.08-0.14,0.27-0.14,0.41
				c0,0.16,0.08,0.29,0.23,0.34c0.21,0.06,0.42,0.13,0.62,0.25c0.38,0.24,0.74,0.5,1.11,0.76c0.17,0.12,0.32,0.13,0.49-0.03
				c0.79-0.71,1.59-1.38,2.38-2.09c0.28-0.25,0.57-0.4,0.91-0.43c0.86-0.08,1.68,0.82,1.77,2c0.09,1.05-0.23,1.86-0.89,2.43
				c-0.68,0.58-1.36,1.17-2.03,1.76c-0.8,0.68-1.59,1.38-2.39,2.04c-0.67,0.55-1.65,0.15-2.07-0.67c-0.17-0.34-0.37-0.63-0.65-0.78
				c-0.41-0.22-0.96-0.05-1.21,0.33c-0.39,0.6-0.42,1.27-0.22,1.82c0.21,0.59,0.55,1.06,0.92,1.47c0.54,0.59,1.15,0.97,1.86,1.12
				c0.78,0.17,1.52,0.09,2.23-0.35c0.49-0.31,0.94-0.72,1.39-1.11c1.01-0.87,2.01-1.75,3.02-2.62c0.67-0.58,1.3-1.19,1.73-2.13
				C72.87,39.92,73.08,38.95,73.1,37.9z M58.2,52.87c0.79,0.02,1.49-0.32,2.06-0.8c1.21-1.04,2.41-2.09,3.61-3.15
				c0.09-0.08,0.16-0.28,0.15-0.42c-0.01-0.12-0.12-0.26-0.21-0.33c-0.14-0.09-0.3-0.11-0.45-0.17c-0.4-0.16-0.78-0.39-1.13-0.69
				c-0.19-0.17-0.38-0.41-0.65-0.15c-0.58,0.54-1.18,1.05-1.78,1.56c-0.36,0.31-0.71,0.68-1.1,0.86c-1,0.45-1.93-0.31-2.19-1.69
				c-0.17-0.88,0.12-1.96,0.72-2.48c1.46-1.26,2.91-2.56,4.37-3.83c0.54-0.47,1.11-0.49,1.69-0.12c0.35,0.22,0.56,0.6,0.78,0.99
				c0.2,0.34,0.47,0.51,0.78,0.54c0.97,0.1,1.46-1.25,1.11-2.17c-0.32-0.83-0.79-1.46-1.38-1.97c-0.68-0.58-1.43-0.82-2.22-0.8
				c-0.76,0.02-1.46,0.37-2.1,0.92c-1.3,1.13-2.59,2.27-3.89,3.4c-0.54,0.46-1.03,0.98-1.41,1.68c-0.33,0.62-0.57,1.31-0.69,2.06
				c-0.18,1.09-0.13,2.17,0.16,3.2c0.32,1.1,0.84,2.02,1.6,2.68C56.7,52.59,57.42,52.87,58.2,52.87z"/>
      <path className={style.st0} d="M73.1,37.9c-0.03,1.05-0.24,2.02-0.65,2.93c-0.43,0.94-1.07,1.55-1.73,2.13c-1.01,0.87-2.01,1.75-3.02,2.62
				c-0.46,0.39-0.91,0.81-1.39,1.11c-0.7,0.44-1.45,0.52-2.23,0.35c-0.7-0.15-1.32-0.53-1.86-1.12c-0.37-0.41-0.7-0.88-0.92-1.47
				c-0.2-0.55-0.18-1.23,0.22-1.82c0.25-0.39,0.8-0.55,1.21-0.33c0.28,0.15,0.49,0.44,0.65,0.78c0.41,0.83,1.4,1.22,2.07,0.67
				c0.81-0.66,1.6-1.35,2.39-2.04c0.68-0.58,1.36-1.17,2.03-1.76c0.66-0.57,0.98-1.38,0.89-2.43c-0.1-1.18-0.91-2.08-1.77-2
				c-0.34,0.03-0.63,0.18-0.91,0.43c-0.79,0.7-1.59,1.38-2.38,2.09c-0.18,0.16-0.32,0.15-0.49,0.03c-0.37-0.26-0.73-0.53-1.11-0.76
				c-0.19-0.12-0.41-0.19-0.62-0.25c-0.15-0.04-0.23-0.17-0.23-0.34c0-0.14,0.06-0.33,0.14-0.41c0.44-0.42,0.89-0.81,1.35-1.2
				c0.81-0.7,1.6-1.42,2.43-2.08c0.69-0.54,1.45-0.76,2.27-0.66c0.75,0.09,1.42,0.43,2.02,1.03c0.68,0.68,1.15,1.56,1.42,2.66
				C73.02,36.64,73.09,37.26,73.1,37.9z"/>
      <path className={style.st0} d="M58.2,52.87c-0.79,0-1.51-0.28-2.17-0.85c-0.77-0.65-1.29-1.58-1.6-2.68c-0.3-1.03-0.34-2.11-0.16-3.2
				c0.12-0.75,0.36-1.44,0.69-2.06c0.37-0.7,0.87-1.22,1.41-1.68c1.3-1.13,2.59-2.27,3.89-3.4c0.64-0.55,1.34-0.9,2.1-0.92
				c0.79-0.02,1.53,0.21,2.22,0.8c0.59,0.5,1.07,1.13,1.38,1.97c0.35,0.92-0.14,2.27-1.11,2.17c-0.31-0.03-0.58-0.2-0.78-0.54
				c-0.22-0.39-0.44-0.77-0.78-0.99c-0.59-0.38-1.15-0.35-1.69,0.12c-1.46,1.27-2.91,2.56-4.37,3.83c-0.61,0.52-0.89,1.61-0.72,2.48
				c0.26,1.37,1.19,2.14,2.19,1.69c0.39-0.18,0.74-0.56,1.1-0.86c0.6-0.51,1.2-1.02,1.78-1.56c0.28-0.26,0.46-0.02,0.65,0.15
				c0.35,0.31,0.73,0.53,1.13,0.69c0.15,0.06,0.31,0.08,0.45,0.17c0.09,0.06,0.21,0.21,0.21,0.33c0.01,0.14-0.06,0.34-0.15,0.42
				c-1.2,1.06-2.4,2.11-3.61,3.15C59.7,52.55,59,52.88,58.2,52.87z"/>
    </g>
  </g>
  <g>
    <g>
      <path className={style.st1} d="M91.03,22.15c-0.01-0.64-0.08-1.26-0.23-1.88c-0.27-1.09-0.74-1.98-1.42-2.66c-0.59-0.6-1.27-0.93-2.02-1.03
				c-0.81-0.1-1.58,0.12-2.27,0.66c-0.83,0.65-1.62,1.38-2.43,2.08c-0.45,0.39-0.91,0.79-1.35,1.2c-0.08,0.08-0.14,0.27-0.14,0.41
				c0,0.16,0.08,0.29,0.23,0.34c0.21,0.06,0.42,0.13,0.62,0.25c0.38,0.24,0.74,0.51,1.11,0.77c0.17,0.12,0.32,0.13,0.49-0.03
				c0.79-0.71,1.59-1.39,2.38-2.09c0.28-0.25,0.57-0.4,0.91-0.43c0.86-0.08,1.68,0.82,1.77,2.01c0.09,1.05-0.23,1.86-0.89,2.44
				c-0.68,0.59-1.36,1.18-2.03,1.76c-0.8,0.68-1.59,1.38-2.39,2.04c-0.67,0.55-1.65,0.16-2.07-0.67c-0.17-0.34-0.37-0.63-0.65-0.78
				c-0.41-0.22-0.96-0.05-1.21,0.33c-0.39,0.6-0.42,1.27-0.22,1.83c0.21,0.59,0.55,1.07,0.92,1.47c0.54,0.59,1.15,0.97,1.86,1.13
				c0.78,0.17,1.52,0.09,2.23-0.35c0.49-0.31,0.94-0.72,1.39-1.11c1.01-0.87,2.01-1.75,3.02-2.63c0.67-0.58,1.3-1.19,1.73-2.13
				C90.8,24.17,91.01,23.2,91.03,22.15z M80.48,22.32c-0.52-0.01-1.01,0.13-1.49,0.37c-0.69,0.35-1.26,0.97-1.88,1.5
				c-0.91,0.77-1.8,1.57-2.7,2.36c-0.47,0.41-0.93,0.83-1.3,1.41c-0.35,0.55-0.61,1.17-0.79,1.86c-0.35,1.39-0.31,2.76,0.13,4.09
				c0.51,1.53,1.36,2.57,2.57,3.04c1.13,0.44,2.21,0.21,3.2-0.63c1.2-1.02,2.38-2.06,3.56-3.11c0.09-0.08,0.15-0.3,0.15-0.44
				c-0.01-0.11-0.13-0.26-0.22-0.32c-0.14-0.09-0.31-0.09-0.45-0.17c-0.37-0.22-0.74-0.45-1.11-0.69c-0.22-0.14-0.4-0.39-0.67-0.14
				c-0.59,0.54-1.18,1.06-1.78,1.57c-0.35,0.3-0.69,0.68-1.08,0.85c-1.08,0.49-2.1-0.48-2.23-1.96c-0.08-0.92,0.17-1.71,0.78-2.24
				c0.23-0.2,0.46-0.41,0.69-0.61c1.21-1.06,2.42-2.12,3.62-3.18c0.55-0.48,1.11-0.52,1.71-0.14c0.35,0.22,0.56,0.6,0.78,0.98
				c0.2,0.35,0.48,0.52,0.8,0.55c0.95,0.09,1.44-1.24,1.1-2.17c-0.31-0.84-0.79-1.47-1.38-1.97C81.88,22.59,81.21,22.35,80.48,22.32
				z"/>
      <path className={style.st1} d="M91.03,22.15c-0.03,1.05-0.24,2.02-0.65,2.93c-0.43,0.94-1.07,1.55-1.73,2.13
				c-1.01,0.87-2.01,1.76-3.02,2.63c-0.46,0.39-0.91,0.81-1.39,1.11c-0.7,0.44-1.45,0.52-2.23,0.35c-0.7-0.15-1.32-0.53-1.86-1.13
				c-0.37-0.41-0.7-0.88-0.92-1.47c-0.2-0.56-0.18-1.23,0.22-1.83c0.25-0.39,0.8-0.55,1.21-0.33c0.28,0.15,0.49,0.44,0.65,0.78
				c0.41,0.83,1.4,1.22,2.07,0.67c0.81-0.66,1.6-1.36,2.39-2.04c0.68-0.58,1.36-1.18,2.03-1.76c0.66-0.57,0.98-1.38,0.89-2.44
				c-0.1-1.19-0.91-2.09-1.77-2.01c-0.34,0.03-0.63,0.18-0.91,0.43c-0.79,0.7-1.59,1.38-2.38,2.09c-0.18,0.16-0.32,0.15-0.49,0.03
				c-0.37-0.26-0.73-0.53-1.11-0.77c-0.19-0.12-0.41-0.19-0.62-0.25c-0.15-0.04-0.23-0.17-0.23-0.34c0-0.14,0.06-0.33,0.14-0.41
				c0.44-0.42,0.89-0.81,1.35-1.2c0.81-0.7,1.6-1.43,2.43-2.08c0.69-0.55,1.45-0.76,2.27-0.66c0.75,0.09,1.42,0.43,2.02,1.03
				c0.68,0.68,1.15,1.57,1.42,2.66C90.95,20.88,91.02,21.51,91.03,22.15z"/>
      <path className={style.st1} d="M80.48,22.32c0.73,0.03,1.4,0.27,2.03,0.8c0.59,0.5,1.07,1.14,1.38,1.97c0.34,0.93-0.15,2.25-1.1,2.17
				c-0.32-0.03-0.59-0.2-0.8-0.55c-0.22-0.39-0.44-0.77-0.78-0.98c-0.6-0.38-1.16-0.34-1.71,0.14c-1.21,1.06-2.42,2.12-3.62,3.18
				c-0.23,0.2-0.46,0.41-0.69,0.61c-0.61,0.53-0.86,1.32-0.78,2.24c0.13,1.49,1.14,2.45,2.23,1.96c0.39-0.18,0.73-0.55,1.08-0.85
				c0.6-0.51,1.19-1.03,1.78-1.57c0.28-0.25,0.46,0,0.67,0.14c0.36,0.24,0.73,0.47,1.11,0.69c0.14,0.08,0.31,0.08,0.45,0.17
				c0.09,0.06,0.21,0.2,0.22,0.32c0.01,0.15-0.06,0.36-0.15,0.44c-1.18,1.05-2.36,2.1-3.56,3.11c-0.99,0.84-2.07,1.07-3.2,0.63
				c-1.21-0.47-2.06-1.5-2.57-3.04c-0.44-1.34-0.49-2.7-0.13-4.09c0.17-0.69,0.44-1.31,0.79-1.86c0.37-0.58,0.83-1,1.3-1.41
				c0.9-0.78,1.8-1.58,2.7-2.36c0.61-0.52,1.18-1.14,1.88-1.5C79.48,22.44,79.97,22.3,80.48,22.32z"/>
    </g>
  </g>
  <g>
    <g>
      <path className={style.st1} d="M36.32,63.16c0.02,0.63,0.08,1.24,0.23,1.85c0.27,1.09,0.74,1.98,1.42,2.66c0.59,0.59,1.27,0.94,2.02,1.03
				c0.82,0.1,1.59-0.11,2.28-0.67c0.87-0.7,1.71-1.46,2.56-2.19c0.4-0.35,0.81-0.69,1.2-1.07c0.08-0.08,0.15-0.27,0.15-0.41
				c0-0.17-0.09-0.29-0.24-0.35c-0.61-0.21-1.2-0.5-1.71-1c-0.14-0.13-0.29-0.17-0.46-0.02c-0.81,0.72-1.65,1.41-2.45,2.15
				c-0.72,0.67-1.77,0.48-2.31-0.47c-0.43-0.76-0.48-1.58-0.21-2.45c0.18-0.57,0.52-0.9,0.89-1.22c1.33-1.15,2.65-2.31,3.97-3.48
				c0.41-0.36,0.85-0.56,1.35-0.41c0.44,0.13,0.79,0.42,1.05,0.93c0.1,0.21,0.23,0.42,0.39,0.55c0.47,0.38,0.91,0.36,1.31-0.03
				c0.38-0.37,0.57-1.02,0.41-1.71c-0.17-0.73-0.57-1.25-0.98-1.72c-0.53-0.61-1.15-0.98-1.85-1.13c-0.75-0.16-1.48-0.12-2.17,0.32
				c-0.5,0.32-0.98,0.73-1.45,1.13c-1.01,0.86-2.01,1.75-3.02,2.62c-0.67,0.58-1.3,1.19-1.74,2.13
				C36.56,61.12,36.35,62.1,36.32,63.16z M46.88,62.97c0.06,0.01,0.13,0.03,0.19,0.02c0.76-0.06,1.46-0.38,2.1-0.93
				c1.34-1.17,2.68-2.36,4.02-3.52c0.9-0.78,1.57-1.82,1.88-3.2c0.33-1.47,0.24-2.9-0.3-4.28c-0.51-1.29-1.27-2.2-2.3-2.64
				c-1.21-0.52-2.37-0.29-3.44,0.65c-1.15,1.01-2.31,2.01-3.46,3.01c-0.14,0.12-0.2,0.28-0.17,0.49c0.03,0.21,0.16,0.26,0.29,0.31
				c0.6,0.2,1.18,0.5,1.68,0.99c0.13,0.13,0.27,0.16,0.42,0.04c0.15-0.13,0.3-0.26,0.45-0.39c0.77-0.66,1.53-1.34,2.31-1.98
				c0.52-0.43,1.3-0.24,1.73,0.23c0.53,0.59,0.78,1.36,0.66,2.28c-0.07,0.58-0.26,1.09-0.62,1.44c-0.27,0.26-0.56,0.5-0.84,0.75
				c-1.21,1.06-2.42,2.12-3.62,3.18c-0.55,0.48-1.11,0.52-1.71,0.14c-0.35-0.22-0.56-0.6-0.78-0.98c-0.2-0.34-0.47-0.51-0.78-0.55
				c-0.97-0.1-1.46,1.24-1.12,2.16c0.31,0.84,0.79,1.47,1.38,1.97C45.48,62.71,46.15,62.95,46.88,62.97z"/>
      <path className={style.st1} d="M36.32,63.16c0.02-1.06,0.24-2.04,0.66-2.95c0.43-0.94,1.07-1.55,1.74-2.13c1.01-0.87,2.01-1.76,3.02-2.62
				c0.47-0.4,0.95-0.81,1.45-1.13c0.69-0.44,1.42-0.48,2.17-0.32c0.7,0.15,1.32,0.52,1.85,1.13c0.41,0.47,0.81,0.99,0.98,1.72
				c0.16,0.69-0.03,1.34-0.41,1.71c-0.4,0.39-0.85,0.41-1.31,0.03c-0.16-0.13-0.29-0.34-0.39-0.55c-0.25-0.51-0.61-0.8-1.05-0.93
				c-0.5-0.15-0.94,0.05-1.35,0.41c-1.32,1.16-2.64,2.33-3.97,3.48c-0.37,0.32-0.71,0.65-0.89,1.22c-0.27,0.88-0.22,1.7,0.21,2.45
				c0.53,0.95,1.58,1.15,2.31,0.47c0.8-0.75,1.63-1.43,2.45-2.15c0.17-0.15,0.32-0.11,0.46,0.02c0.52,0.5,1.1,0.8,1.71,1
				c0.16,0.05,0.25,0.18,0.24,0.35c0,0.14-0.06,0.33-0.15,0.41c-0.39,0.37-0.8,0.72-1.2,1.07c-0.85,0.74-1.69,1.5-2.56,2.19
				c-0.69,0.56-1.46,0.77-2.28,0.67c-0.75-0.09-1.42-0.44-2.02-1.03c-0.68-0.68-1.15-1.57-1.42-2.66
				C36.4,64.41,36.34,63.79,36.32,63.16z"/>
      <path className={style.st1} d="M46.88,62.97c-0.73-0.02-1.4-0.26-2.03-0.79c-0.59-0.5-1.07-1.13-1.38-1.97c-0.35-0.93,0.15-2.27,1.12-2.16
				c0.31,0.03,0.58,0.2,0.78,0.55c0.22,0.39,0.44,0.77,0.78,0.98c0.6,0.38,1.16,0.34,1.71-0.14c1.21-1.06,2.42-2.12,3.62-3.18
				c0.28-0.25,0.57-0.49,0.84-0.75c0.37-0.35,0.55-0.87,0.62-1.44c0.11-0.93-0.13-1.7-0.66-2.28c-0.43-0.47-1.2-0.66-1.73-0.23
				c-0.78,0.64-1.54,1.32-2.31,1.98c-0.15,0.13-0.3,0.26-0.45,0.39c-0.15,0.13-0.29,0.09-0.42-0.04c-0.51-0.49-1.08-0.79-1.68-0.99
				c-0.13-0.04-0.26-0.09-0.29-0.31c-0.03-0.21,0.03-0.37,0.17-0.49c1.15-1,2.31-2,3.46-3.01c1.07-0.94,2.23-1.18,3.44-0.65
				c1.03,0.44,1.8,1.35,2.3,2.64c0.54,1.38,0.63,2.81,0.3,4.28c-0.31,1.38-0.98,2.42-1.88,3.2c-1.35,1.16-2.68,2.35-4.02,3.52
				c-0.64,0.55-1.34,0.87-2.1,0.93C47.01,62.99,46.94,62.98,46.88,62.97z"/>
    </g>
  </g>
  <g>
    <g>
      <path className={style.st1} d="M18.3,78.82c0.02,0.63,0.08,1.24,0.23,1.85c0.27,1.09,0.74,1.98,1.42,2.66c0.59,0.59,1.27,0.94,2.02,1.03
				c0.82,0.1,1.59-0.11,2.28-0.67c0.87-0.7,1.71-1.46,2.56-2.19c0.4-0.35,0.81-0.69,1.2-1.07c0.08-0.08,0.15-0.27,0.15-0.41
				c0-0.17-0.09-0.29-0.24-0.35c-0.61-0.21-1.2-0.5-1.71-1c-0.14-0.13-0.29-0.17-0.46-0.02c-0.81,0.72-1.65,1.41-2.45,2.15
				c-0.72,0.67-1.77,0.48-2.31-0.47c-0.43-0.76-0.48-1.58-0.21-2.45c0.18-0.57,0.52-0.9,0.89-1.22c1.33-1.15,2.65-2.31,3.97-3.48
				c0.41-0.36,0.85-0.56,1.35-0.41c0.44,0.13,0.79,0.42,1.05,0.93c0.1,0.21,0.23,0.42,0.39,0.55c0.47,0.38,0.91,0.36,1.31-0.03
				c0.38-0.37,0.57-1.02,0.41-1.71c-0.17-0.73-0.57-1.25-0.98-1.72c-0.53-0.61-1.15-0.98-1.85-1.13c-0.75-0.16-1.48-0.12-2.17,0.32
				c-0.5,0.32-0.98,0.73-1.45,1.13c-1.01,0.86-2.01,1.75-3.02,2.62c-0.67,0.58-1.3,1.19-1.74,2.13
				C18.54,76.78,18.33,77.76,18.3,78.82z M28.86,78.62c0.06,0.01,0.13,0.03,0.19,0.02c0.76-0.06,1.46-0.38,2.1-0.93
				c1.34-1.17,2.68-2.36,4.02-3.52c0.9-0.78,1.57-1.82,1.88-3.2c0.33-1.47,0.24-2.9-0.3-4.28c-0.51-1.29-1.27-2.2-2.3-2.64
				c-1.21-0.52-2.37-0.29-3.44,0.65c-1.15,1.01-2.31,2.01-3.46,3.01c-0.14,0.12-0.2,0.28-0.17,0.49c0.03,0.21,0.16,0.26,0.29,0.31
				c0.6,0.2,1.18,0.5,1.68,0.99c0.13,0.13,0.27,0.16,0.42,0.04c0.15-0.13,0.3-0.26,0.45-0.39c0.77-0.66,1.53-1.34,2.31-1.98
				c0.52-0.43,1.3-0.24,1.73,0.23c0.53,0.59,0.78,1.36,0.66,2.28c-0.07,0.58-0.26,1.09-0.62,1.44c-0.27,0.26-0.56,0.5-0.84,0.75
				c-1.21,1.06-2.42,2.12-3.62,3.18c-0.55,0.48-1.11,0.52-1.71,0.14c-0.35-0.22-0.56-0.6-0.78-0.98c-0.2-0.34-0.47-0.51-0.78-0.55
				c-0.97-0.1-1.46,1.24-1.12,2.16c0.31,0.84,0.79,1.47,1.38,1.97C27.46,78.36,28.13,78.6,28.86,78.62z"/>
      <path className={style.st1} d="M18.3,78.82c0.02-1.06,0.24-2.04,0.66-2.95c0.43-0.94,1.07-1.55,1.74-2.13c1.01-0.87,2.01-1.76,3.02-2.62
				c0.47-0.4,0.95-0.81,1.45-1.13c0.69-0.44,1.42-0.48,2.17-0.32c0.7,0.15,1.32,0.52,1.85,1.13c0.41,0.47,0.81,0.99,0.98,1.72
				c0.16,0.69-0.03,1.34-0.41,1.71c-0.4,0.39-0.85,0.41-1.31,0.03c-0.16-0.13-0.29-0.34-0.39-0.55c-0.25-0.51-0.61-0.8-1.05-0.93
				c-0.5-0.15-0.94,0.05-1.35,0.41c-1.32,1.16-2.64,2.33-3.97,3.48c-0.37,0.32-0.71,0.65-0.89,1.22c-0.27,0.88-0.22,1.7,0.21,2.45
				c0.53,0.95,1.58,1.15,2.31,0.47c0.8-0.75,1.63-1.43,2.45-2.15c0.17-0.15,0.32-0.11,0.46,0.02c0.52,0.5,1.1,0.8,1.71,1
				c0.16,0.05,0.25,0.18,0.24,0.35c0,0.14-0.06,0.33-0.15,0.41c-0.39,0.37-0.8,0.72-1.2,1.07c-0.85,0.74-1.69,1.5-2.56,2.19
				c-0.69,0.56-1.46,0.77-2.28,0.67c-0.75-0.09-1.42-0.44-2.02-1.03c-0.68-0.68-1.15-1.57-1.42-2.66
				C18.38,80.06,18.32,79.45,18.3,78.82z"/>
      <path className={style.st1} d="M28.86,78.62c-0.73-0.02-1.4-0.26-2.03-0.79c-0.59-0.5-1.07-1.13-1.38-1.97c-0.35-0.93,0.15-2.27,1.12-2.16
				c0.31,0.03,0.58,0.2,0.78,0.55c0.22,0.39,0.44,0.77,0.78,0.98c0.6,0.38,1.16,0.34,1.71-0.14c1.21-1.06,2.42-2.12,3.62-3.18
				c0.28-0.25,0.57-0.49,0.84-0.75c0.37-0.35,0.55-0.87,0.62-1.44c0.11-0.93-0.13-1.7-0.66-2.28c-0.43-0.47-1.2-0.66-1.73-0.23
				c-0.78,0.64-1.54,1.32-2.31,1.98c-0.15,0.13-0.3,0.26-0.45,0.39c-0.15,0.13-0.29,0.09-0.42-0.04c-0.51-0.49-1.08-0.79-1.68-0.99
				c-0.13-0.04-0.26-0.09-0.29-0.31c-0.03-0.21,0.03-0.37,0.17-0.49c1.15-1,2.31-2,3.46-3.01c1.07-0.94,2.23-1.18,3.44-0.65
				c1.03,0.44,1.8,1.35,2.3,2.64c0.54,1.38,0.63,2.81,0.3,4.28c-0.31,1.38-0.98,2.42-1.88,3.2c-1.35,1.16-2.68,2.35-4.02,3.52
				c-0.64,0.55-1.34,0.87-2.1,0.93C28.99,78.65,28.92,78.63,28.86,78.62z"/>
    </g>
  </g>
  <rect x="18.3" y="77.59" width="72.73" height="7.3"/>
</g>
<g>
  <g>
    <g>
      <path className={style.st0} d="M109.62,40.82c0.43,0.94,1.07,1.55,1.73,2.13c1.01,0.87,2.01,1.75,3.02,2.62c0.46,0.39,0.91,0.81,1.39,1.11
				c0.7,0.44,1.45,0.52,2.23,0.35c0.7-0.15,1.32-0.53,1.86-1.12c0.37-0.41,0.7-0.88,0.92-1.47c0.2-0.55,0.18-1.23-0.22-1.82
				c-0.25-0.39-0.8-0.55-1.21-0.33c-0.28,0.15-0.49,0.44-0.65,0.78c-0.41,0.83-1.4,1.22-2.07,0.67c-0.81-0.66-1.6-1.35-2.39-2.04
				c-0.68-0.58-1.36-1.17-2.03-1.76c-0.66-0.57-0.98-1.38-0.89-2.43c0.1-1.18,0.91-2.08,1.77-2c0.34,0.03,0.63,0.18,0.91,0.43
				c0.79,0.7,1.59,1.38,2.38,2.09c0.18,0.16,0.32,0.15,0.49,0.03c0.37-0.26,0.73-0.53,1.11-0.76c0.19-0.12,0.41-0.19,0.62-0.25
				c0.15-0.04,0.23-0.17,0.23-0.34c0-0.14-0.06-0.33-0.14-0.41c-0.44-0.42-0.89-0.81-1.35-1.2c-0.81-0.7-1.6-1.42-2.43-2.08
				c-0.69-0.54-1.45-0.76-2.27-0.66c-0.75,0.09-1.42,0.43-2.02,1.03c-0.68,0.68-1.15,1.56-1.42,2.66c-0.15,0.62-0.22,1.24-0.23,1.88
				C108.99,38.95,109.2,39.92,109.62,40.82z M126.04,52.01c0.77-0.65,1.29-1.58,1.6-2.68c0.3-1.03,0.34-2.11,0.16-3.2
				c-0.12-0.75-0.36-1.44-0.69-2.06c-0.37-0.7-0.87-1.22-1.41-1.68c-1.3-1.13-2.59-2.27-3.89-3.4c-0.64-0.55-1.34-0.9-2.1-0.92
				c-0.79-0.02-1.53,0.21-2.22,0.8c-0.59,0.5-1.07,1.13-1.38,1.97c-0.35,0.92,0.14,2.27,1.11,2.17c0.31-0.03,0.58-0.2,0.78-0.54
				c0.22-0.39,0.44-0.77,0.78-0.99c0.59-0.38,1.15-0.35,1.69,0.12c1.46,1.27,2.91,2.56,4.37,3.83c0.61,0.52,0.89,1.61,0.72,2.48
				c-0.26,1.37-1.19,2.14-2.19,1.69c-0.39-0.18-0.74-0.56-1.1-0.86c-0.6-0.51-1.2-1.02-1.78-1.56c-0.28-0.26-0.46-0.02-0.65,0.15
				c-0.35,0.31-0.73,0.53-1.13,0.69c-0.15,0.06-0.31,0.08-0.45,0.17c-0.09,0.06-0.21,0.21-0.21,0.33c-0.01,0.14,0.06,0.34,0.15,0.42
				c1.2,1.06,2.4,2.11,3.61,3.15c0.56,0.48,1.27,0.81,2.06,0.8C124.65,52.87,125.37,52.59,126.04,52.01z"/>
      <path className={style.st0} d="M108.96,37.9c0.03,1.05,0.24,2.02,0.65,2.93c0.43,0.94,1.07,1.55,1.73,2.13c1.01,0.87,2.01,1.75,3.02,2.62
				c0.46,0.39,0.91,0.81,1.39,1.11c0.7,0.44,1.45,0.52,2.23,0.35c0.7-0.15,1.32-0.53,1.86-1.12c0.37-0.41,0.7-0.88,0.92-1.47
				c0.2-0.55,0.18-1.23-0.22-1.82c-0.25-0.39-0.8-0.55-1.21-0.33c-0.28,0.15-0.49,0.44-0.65,0.78c-0.41,0.83-1.4,1.22-2.07,0.67
				c-0.81-0.66-1.6-1.35-2.39-2.04c-0.68-0.58-1.36-1.17-2.03-1.76c-0.66-0.57-0.98-1.38-0.89-2.43c0.1-1.18,0.91-2.08,1.77-2
				c0.34,0.03,0.63,0.18,0.91,0.43c0.79,0.7,1.59,1.38,2.38,2.09c0.18,0.16,0.32,0.15,0.49,0.03c0.37-0.26,0.73-0.53,1.11-0.76
				c0.19-0.12,0.41-0.19,0.62-0.25c0.15-0.04,0.23-0.17,0.23-0.34c0-0.14-0.06-0.33-0.14-0.41c-0.44-0.42-0.89-0.81-1.35-1.2
				c-0.81-0.7-1.6-1.42-2.43-2.08c-0.69-0.54-1.45-0.76-2.27-0.66c-0.75,0.09-1.42,0.43-2.02,1.03c-0.68,0.68-1.15,1.56-1.42,2.66
				C109.04,36.64,108.98,37.26,108.96,37.9z"/>
      <path className={style.st0} d="M123.86,52.87c0.79,0,1.51-0.28,2.17-0.85c0.77-0.65,1.29-1.58,1.6-2.68c0.3-1.03,0.34-2.11,0.16-3.2
				c-0.12-0.75-0.36-1.44-0.69-2.06c-0.37-0.7-0.87-1.22-1.41-1.68c-1.3-1.13-2.59-2.27-3.89-3.4c-0.64-0.55-1.34-0.9-2.1-0.92
				c-0.79-0.02-1.53,0.21-2.22,0.8c-0.59,0.5-1.07,1.13-1.38,1.97c-0.35,0.92,0.14,2.27,1.11,2.17c0.31-0.03,0.58-0.2,0.78-0.54
				c0.22-0.39,0.44-0.77,0.78-0.99c0.59-0.38,1.15-0.35,1.69,0.12c1.46,1.27,2.91,2.56,4.37,3.83c0.61,0.52,0.89,1.61,0.72,2.48
				c-0.26,1.37-1.19,2.14-2.19,1.69c-0.39-0.18-0.74-0.56-1.1-0.86c-0.6-0.51-1.2-1.02-1.78-1.56c-0.28-0.26-0.46-0.02-0.65,0.15
				c-0.35,0.31-0.73,0.53-1.13,0.69c-0.15,0.06-0.31,0.08-0.45,0.17c-0.09,0.06-0.21,0.21-0.21,0.33c-0.01,0.14,0.06,0.34,0.15,0.42
				c1.2,1.06,2.4,2.11,3.61,3.15C122.37,52.55,123.07,52.88,123.86,52.87z"/>
    </g>
  </g>
  <g>
    <g>
      <path className={style.st1} d="M91.69,25.08c0.43,0.94,1.07,1.55,1.73,2.13c1.01,0.87,2.01,1.76,3.02,2.63c0.46,0.39,0.91,0.81,1.39,1.11
				c0.7,0.44,1.45,0.52,2.23,0.35c0.7-0.15,1.32-0.53,1.86-1.13c0.37-0.41,0.7-0.88,0.92-1.47c0.2-0.56,0.18-1.23-0.22-1.83
				c-0.25-0.39-0.8-0.55-1.21-0.33c-0.28,0.15-0.49,0.44-0.65,0.78c-0.41,0.83-1.4,1.22-2.07,0.67c-0.81-0.66-1.6-1.36-2.39-2.04
				c-0.68-0.58-1.36-1.18-2.03-1.76c-0.66-0.57-0.98-1.38-0.89-2.44c0.1-1.19,0.91-2.09,1.77-2.01c0.34,0.03,0.63,0.18,0.91,0.43
				c0.79,0.7,1.59,1.38,2.38,2.09c0.18,0.16,0.32,0.15,0.49,0.03c0.37-0.26,0.73-0.53,1.11-0.77c0.19-0.12,0.41-0.19,0.62-0.25
				c0.15-0.04,0.23-0.17,0.23-0.34c0-0.14-0.06-0.33-0.14-0.41c-0.44-0.42-0.89-0.81-1.35-1.2c-0.81-0.7-1.6-1.43-2.43-2.08
				c-0.69-0.55-1.45-0.76-2.27-0.66c-0.75,0.09-1.42,0.43-2.02,1.03c-0.68,0.68-1.15,1.57-1.42,2.66c-0.15,0.62-0.22,1.24-0.23,1.88
				C91.06,23.2,91.27,24.17,91.69,25.08z M99.56,23.12c-0.59,0.5-1.07,1.14-1.38,1.97c-0.34,0.93,0.15,2.25,1.1,2.17
				c0.32-0.03,0.59-0.2,0.8-0.55c0.22-0.39,0.44-0.77,0.78-0.98c0.6-0.38,1.16-0.34,1.71,0.14c1.21,1.06,2.42,2.12,3.62,3.18
				c0.23,0.2,0.46,0.41,0.69,0.61c0.61,0.53,0.86,1.32,0.78,2.24c-0.13,1.49-1.14,2.45-2.23,1.96c-0.39-0.18-0.73-0.55-1.08-0.85
				c-0.6-0.51-1.19-1.03-1.78-1.57c-0.28-0.25-0.46,0-0.67,0.14c-0.36,0.24-0.73,0.47-1.11,0.69c-0.14,0.08-0.31,0.08-0.45,0.17
				c-0.09,0.06-0.21,0.2-0.22,0.32c-0.01,0.15,0.06,0.36,0.15,0.44c1.18,1.05,2.36,2.1,3.56,3.11c0.99,0.84,2.07,1.07,3.2,0.63
				c1.21-0.47,2.06-1.5,2.57-3.04c0.44-1.34,0.49-2.7,0.13-4.09c-0.17-0.69-0.44-1.31-0.79-1.86c-0.37-0.58-0.83-1-1.3-1.41
				c-0.9-0.78-1.8-1.58-2.7-2.36c-0.61-0.52-1.18-1.14-1.88-1.5c-0.48-0.25-0.97-0.39-1.49-0.37
				C100.86,22.35,100.18,22.59,99.56,23.12z"/>
      <path className={style.st1} d="M91.03,22.15c0.03,1.05,0.24,2.02,0.65,2.93c0.43,0.94,1.07,1.55,1.73,2.13c1.01,0.87,2.01,1.76,3.02,2.63
				c0.46,0.39,0.91,0.81,1.39,1.11c0.7,0.44,1.45,0.52,2.23,0.35c0.7-0.15,1.32-0.53,1.86-1.13c0.37-0.41,0.7-0.88,0.92-1.47
				c0.2-0.56,0.18-1.23-0.22-1.83c-0.25-0.39-0.8-0.55-1.21-0.33c-0.28,0.15-0.49,0.44-0.65,0.78c-0.41,0.83-1.4,1.22-2.07,0.67
				c-0.81-0.66-1.6-1.36-2.39-2.04c-0.68-0.58-1.36-1.18-2.03-1.76c-0.66-0.57-0.98-1.38-0.89-2.44c0.1-1.19,0.91-2.09,1.77-2.01
				c0.34,0.03,0.63,0.18,0.91,0.43c0.79,0.7,1.59,1.38,2.38,2.09c0.18,0.16,0.32,0.15,0.49,0.03c0.37-0.26,0.73-0.53,1.11-0.77
				c0.19-0.12,0.41-0.19,0.62-0.25c0.15-0.04,0.23-0.17,0.23-0.34c0-0.14-0.06-0.33-0.14-0.41c-0.44-0.42-0.89-0.81-1.35-1.2
				c-0.81-0.7-1.6-1.43-2.43-2.08c-0.69-0.55-1.45-0.76-2.27-0.66c-0.75,0.09-1.42,0.43-2.02,1.03c-0.68,0.68-1.15,1.57-1.42,2.66
				C91.12,20.88,91.05,21.51,91.03,22.15z"/>
      <path className={style.st1} d="M101.59,22.32c-0.73,0.03-1.4,0.27-2.03,0.8c-0.59,0.5-1.07,1.14-1.38,1.97c-0.34,0.93,0.15,2.25,1.1,2.17
				c0.32-0.03,0.59-0.2,0.8-0.55c0.22-0.39,0.44-0.77,0.78-0.98c0.6-0.38,1.16-0.34,1.71,0.14c1.21,1.06,2.42,2.12,3.62,3.18
				c0.23,0.2,0.46,0.41,0.69,0.61c0.61,0.53,0.86,1.32,0.78,2.24c-0.13,1.49-1.14,2.45-2.23,1.96c-0.39-0.18-0.73-0.55-1.08-0.85
				c-0.6-0.51-1.19-1.03-1.78-1.57c-0.28-0.25-0.46,0-0.67,0.14c-0.36,0.24-0.73,0.47-1.11,0.69c-0.14,0.08-0.31,0.08-0.45,0.17
				c-0.09,0.06-0.21,0.2-0.22,0.32c-0.01,0.15,0.06,0.36,0.15,0.44c1.18,1.05,2.36,2.1,3.56,3.11c0.99,0.84,2.07,1.07,3.2,0.63
				c1.21-0.47,2.06-1.5,2.57-3.04c0.44-1.34,0.49-2.7,0.13-4.09c-0.17-0.69-0.44-1.31-0.79-1.86c-0.37-0.58-0.83-1-1.3-1.41
				c-0.9-0.78-1.8-1.58-2.7-2.36c-0.61-0.52-1.18-1.14-1.88-1.5C102.59,22.44,102.1,22.3,101.59,22.32z"/>
    </g>
  </g>
  <g>
    <g>
      <path className={style.st1} d="M145.09,60.21c-0.43-0.94-1.07-1.55-1.74-2.13c-1.01-0.87-2.01-1.76-3.02-2.62
				c-0.47-0.4-0.95-0.81-1.45-1.13c-0.69-0.44-1.42-0.48-2.17-0.32c-0.7,0.15-1.32,0.52-1.85,1.13c-0.41,0.47-0.81,0.99-0.98,1.72
				c-0.16,0.69,0.03,1.34,0.41,1.71c0.4,0.39,0.85,0.41,1.31,0.03c0.16-0.13,0.29-0.34,0.39-0.55c0.25-0.51,0.61-0.8,1.05-0.93
				c0.5-0.15,0.94,0.05,1.35,0.41c1.32,1.16,2.64,2.33,3.97,3.48c0.37,0.32,0.71,0.65,0.89,1.22c0.27,0.88,0.22,1.7-0.21,2.45
				c-0.53,0.95-1.58,1.15-2.31,0.47c-0.8-0.75-1.63-1.43-2.45-2.15c-0.17-0.15-0.32-0.11-0.46,0.02c-0.52,0.5-1.1,0.8-1.71,1
				c-0.16,0.05-0.25,0.18-0.24,0.35c0,0.14,0.06,0.33,0.15,0.41c0.39,0.37,0.8,0.72,1.2,1.07c0.85,0.74,1.69,1.5,2.56,2.19
				c0.69,0.56,1.46,0.77,2.28,0.67c0.75-0.09,1.42-0.44,2.02-1.03c0.68-0.68,1.15-1.57,1.42-2.66c0.15-0.61,0.21-1.22,0.23-1.85
				C145.72,62.1,145.51,61.12,145.09,60.21z M137.22,62.18c0.59-0.5,1.07-1.13,1.38-1.97c0.35-0.93-0.15-2.27-1.12-2.16
				c-0.31,0.03-0.58,0.2-0.78,0.55c-0.22,0.39-0.44,0.77-0.78,0.98c-0.6,0.38-1.16,0.34-1.71-0.14c-1.21-1.06-2.42-2.12-3.62-3.18
				c-0.28-0.25-0.57-0.49-0.84-0.75c-0.37-0.35-0.55-0.87-0.62-1.44c-0.11-0.93,0.13-1.7,0.66-2.28c0.43-0.47,1.2-0.66,1.73-0.23
				c0.78,0.64,1.54,1.32,2.31,1.98c0.15,0.13,0.3,0.26,0.45,0.39c0.15,0.13,0.29,0.09,0.42-0.04c0.51-0.49,1.08-0.79,1.68-0.99
				c0.13-0.04,0.26-0.09,0.29-0.31c0.03-0.21-0.03-0.37-0.17-0.49c-1.15-1-2.31-2-3.46-3.01c-1.07-0.94-2.23-1.18-3.44-0.65
				c-1.03,0.44-1.8,1.35-2.3,2.64c-0.54,1.38-0.63,2.81-0.3,4.28c0.31,1.38,0.98,2.42,1.88,3.2c1.35,1.16,2.68,2.35,4.02,3.52
				c0.64,0.55,1.34,0.87,2.1,0.93c0.06,0.01,0.13-0.01,0.19-0.02C135.92,62.95,136.59,62.71,137.22,62.18z"/>
      <path className={style.st1} d="M145.75,63.16c-0.02-1.06-0.24-2.04-0.66-2.95c-0.43-0.94-1.07-1.55-1.74-2.13
				c-1.01-0.87-2.01-1.76-3.02-2.62c-0.47-0.4-0.95-0.81-1.45-1.13c-0.69-0.44-1.42-0.48-2.17-0.32c-0.7,0.15-1.32,0.52-1.85,1.13
				c-0.41,0.47-0.81,0.99-0.98,1.72c-0.16,0.69,0.03,1.34,0.41,1.71c0.4,0.39,0.85,0.41,1.31,0.03c0.16-0.13,0.29-0.34,0.39-0.55
				c0.25-0.51,0.61-0.8,1.05-0.93c0.5-0.15,0.94,0.05,1.35,0.41c1.32,1.16,2.64,2.33,3.97,3.48c0.37,0.32,0.71,0.65,0.89,1.22
				c0.27,0.88,0.22,1.7-0.21,2.45c-0.53,0.95-1.58,1.15-2.31,0.47c-0.8-0.75-1.63-1.43-2.45-2.15c-0.17-0.15-0.32-0.11-0.46,0.02
				c-0.52,0.5-1.1,0.8-1.71,1c-0.16,0.05-0.25,0.18-0.24,0.35c0,0.14,0.06,0.33,0.15,0.41c0.39,0.37,0.8,0.72,1.2,1.07
				c0.85,0.74,1.69,1.5,2.56,2.19c0.69,0.56,1.46,0.77,2.28,0.67c0.75-0.09,1.42-0.44,2.02-1.03c0.68-0.68,1.15-1.57,1.42-2.66
				C145.66,64.41,145.73,63.79,145.75,63.16z"/>
      <path className={style.st1} d="M135.19,62.97c0.73-0.02,1.4-0.26,2.03-0.79c0.59-0.5,1.07-1.13,1.38-1.97c0.35-0.93-0.15-2.27-1.12-2.16
				c-0.31,0.03-0.58,0.2-0.78,0.55c-0.22,0.39-0.44,0.77-0.78,0.98c-0.6,0.38-1.16,0.34-1.71-0.14c-1.21-1.06-2.42-2.12-3.62-3.18
				c-0.28-0.25-0.57-0.49-0.84-0.75c-0.37-0.35-0.55-0.87-0.62-1.44c-0.11-0.93,0.13-1.7,0.66-2.28c0.43-0.47,1.2-0.66,1.73-0.23
				c0.78,0.64,1.54,1.32,2.31,1.98c0.15,0.13,0.3,0.26,0.45,0.39c0.15,0.13,0.29,0.09,0.42-0.04c0.51-0.49,1.08-0.79,1.68-0.99
				c0.13-0.04,0.26-0.09,0.29-0.31c0.03-0.21-0.03-0.37-0.17-0.49c-1.15-1-2.31-2-3.46-3.01c-1.07-0.94-2.23-1.18-3.44-0.65
				c-1.03,0.44-1.8,1.35-2.3,2.64c-0.54,1.38-0.63,2.81-0.3,4.28c0.31,1.38,0.98,2.42,1.88,3.2c1.35,1.16,2.68,2.35,4.02,3.52
				c0.64,0.55,1.34,0.87,2.1,0.93C135.06,62.99,135.13,62.98,135.19,62.97z"/>
    </g>
  </g>
  <g>
    <g>
      <path className={style.st1} d="M163.11,75.87c-0.43-0.94-1.07-1.55-1.74-2.13c-1.01-0.87-2.01-1.76-3.02-2.62
				c-0.47-0.4-0.95-0.81-1.45-1.13c-0.69-0.44-1.42-0.48-2.17-0.32c-0.7,0.15-1.32,0.52-1.85,1.13c-0.41,0.47-0.81,0.99-0.98,1.72
				c-0.16,0.69,0.03,1.34,0.41,1.71c0.4,0.39,0.85,0.41,1.31,0.03c0.16-0.13,0.29-0.34,0.39-0.55c0.25-0.51,0.61-0.8,1.05-0.93
				c0.5-0.15,0.94,0.05,1.35,0.41c1.32,1.16,2.64,2.33,3.97,3.48c0.37,0.32,0.71,0.65,0.89,1.22c0.27,0.88,0.22,1.7-0.21,2.45
				c-0.53,0.95-1.58,1.15-2.31,0.47c-0.8-0.75-1.63-1.43-2.45-2.15c-0.17-0.15-0.32-0.11-0.46,0.02c-0.52,0.5-1.1,0.8-1.71,1
				c-0.16,0.05-0.25,0.18-0.24,0.35c0,0.14,0.06,0.33,0.15,0.41c0.39,0.37,0.8,0.72,1.2,1.07c0.85,0.74,1.69,1.5,2.56,2.19
				c0.69,0.56,1.46,0.77,2.28,0.67c0.75-0.09,1.42-0.44,2.02-1.03c0.68-0.68,1.15-1.57,1.42-2.66c0.15-0.61,0.21-1.22,0.23-1.85
				C163.74,77.76,163.53,76.78,163.11,75.87z M155.24,77.83c0.59-0.5,1.07-1.13,1.38-1.97c0.35-0.93-0.15-2.27-1.12-2.16
				c-0.31,0.03-0.58,0.2-0.78,0.55c-0.22,0.39-0.44,0.77-0.78,0.98c-0.6,0.38-1.16,0.34-1.71-0.14c-1.21-1.06-2.42-2.12-3.62-3.18
				c-0.28-0.25-0.57-0.49-0.84-0.75c-0.37-0.35-0.55-0.87-0.62-1.44c-0.11-0.93,0.13-1.7,0.66-2.28c0.43-0.47,1.2-0.66,1.73-0.23
				c0.78,0.64,1.54,1.32,2.31,1.98c0.15,0.13,0.3,0.26,0.45,0.39c0.15,0.13,0.29,0.09,0.42-0.04c0.51-0.49,1.08-0.79,1.68-0.99
				c0.13-0.04,0.26-0.09,0.29-0.31c0.03-0.21-0.03-0.37-0.17-0.49c-1.15-1-2.31-2-3.46-3.01c-1.07-0.94-2.23-1.18-3.44-0.65
				c-1.03,0.44-1.8,1.35-2.3,2.64c-0.54,1.38-0.63,2.81-0.3,4.28c0.31,1.38,0.98,2.42,1.88,3.2c1.35,1.16,2.68,2.35,4.02,3.52
				c0.64,0.55,1.34,0.87,2.1,0.93c0.06,0.01,0.13-0.01,0.19-0.02C153.94,78.6,154.61,78.36,155.24,77.83z"/>
      <path className={style.st1} d="M163.77,78.82c-0.02-1.06-0.24-2.04-0.66-2.95c-0.43-0.94-1.07-1.55-1.74-2.13
				c-1.01-0.87-2.01-1.76-3.02-2.62c-0.47-0.4-0.95-0.81-1.45-1.13c-0.69-0.44-1.42-0.48-2.17-0.32c-0.7,0.15-1.32,0.52-1.85,1.13
				c-0.41,0.47-0.81,0.99-0.98,1.72c-0.16,0.69,0.03,1.34,0.41,1.71c0.4,0.39,0.85,0.41,1.31,0.03c0.16-0.13,0.29-0.34,0.39-0.55
				c0.25-0.51,0.61-0.8,1.05-0.93c0.5-0.15,0.94,0.05,1.35,0.41c1.32,1.16,2.64,2.33,3.97,3.48c0.37,0.32,0.71,0.65,0.89,1.22
				c0.27,0.88,0.22,1.7-0.21,2.45c-0.53,0.95-1.58,1.15-2.31,0.47c-0.8-0.75-1.63-1.43-2.45-2.15c-0.17-0.15-0.32-0.11-0.46,0.02
				c-0.52,0.5-1.1,0.8-1.71,1c-0.16,0.05-0.25,0.18-0.24,0.35c0,0.14,0.06,0.33,0.15,0.41c0.39,0.37,0.8,0.72,1.2,1.07
				c0.85,0.74,1.69,1.5,2.56,2.19c0.69,0.56,1.46,0.77,2.28,0.67c0.75-0.09,1.42-0.44,2.02-1.03c0.68-0.68,1.15-1.57,1.42-2.66
				C163.69,80.06,163.75,79.45,163.77,78.82z"/>
      <path className={style.st1} d="M153.21,78.62c0.73-0.02,1.4-0.26,2.03-0.79c0.59-0.5,1.07-1.13,1.38-1.97c0.35-0.93-0.15-2.27-1.12-2.16
				c-0.31,0.03-0.58,0.2-0.78,0.55c-0.22,0.39-0.44,0.77-0.78,0.98c-0.6,0.38-1.16,0.34-1.71-0.14c-1.21-1.06-2.42-2.12-3.62-3.18
				c-0.28-0.25-0.57-0.49-0.84-0.75c-0.37-0.35-0.55-0.87-0.62-1.44c-0.11-0.93,0.13-1.7,0.66-2.28c0.43-0.47,1.2-0.66,1.73-0.23
				c0.78,0.64,1.54,1.32,2.31,1.98c0.15,0.13,0.3,0.26,0.45,0.39c0.15,0.13,0.29,0.09,0.42-0.04c0.51-0.49,1.08-0.79,1.68-0.99
				c0.13-0.04,0.26-0.09,0.29-0.31c0.03-0.21-0.03-0.37-0.17-0.49c-1.15-1-2.31-2-3.46-3.01c-1.07-0.94-2.23-1.18-3.44-0.65
				c-1.03,0.44-1.8,1.35-2.3,2.64c-0.54,1.38-0.63,2.81-0.3,4.28c0.31,1.38,0.98,2.42,1.88,3.2c1.35,1.16,2.68,2.35,4.02,3.52
				c0.64,0.55,1.34,0.87,2.1,0.93C153.08,78.65,153.15,78.63,153.21,78.62z"/>
    </g>
  </g>
  <rect x="91.03" y="77.59" transform="matrix(-1 -6.142344e-11 6.142344e-11 -1 254.8009 162.4816)" width="72.73" height="7.3"/>
</g>
<path className={style.st0} d="M86.54,54.48c0,5.45,2.29,8.17,6.86,8.17c0.82,0,1.6-0.08,2.33-0.23c0.73-0.15,1.62-0.41,2.68-0.77
	c0.85,1.85,1.41,3.75,1.7,5.7c-0.74,0.28-1.44,0.51-2.08,0.69c-0.64,0.18-1.26,0.31-1.85,0.4c-0.59,0.09-1.18,0.15-1.75,0.19
	c-0.58,0.04-1.17,0.06-1.79,0.06c-2.18,0-4.11-0.35-5.76-1.06c-1.66-0.71-3.04-1.69-4.16-2.95c-1.12-1.26-1.96-2.76-2.52-4.51
	c-0.57-1.75-0.85-3.65-0.85-5.7c0-2.05,0.29-3.96,0.89-5.72c0.59-1.76,1.45-3.28,2.56-4.57c1.12-1.29,2.5-2.29,4.14-3.01
	c1.64-0.72,3.51-1.08,5.59-1.08c1.23,0,2.4,0.09,3.51,0.27c1.1,0.18,2.34,0.54,3.7,1.08c-0.05,1.05-0.24,2.08-0.58,3.06
	c-0.33,0.99-0.68,1.86-1.04,2.6c-0.52-0.18-0.98-0.33-1.41-0.46c-0.42-0.13-0.83-0.23-1.21-0.31c-0.38-0.08-0.77-0.14-1.16-0.17
	c-0.39-0.04-0.8-0.06-1.23-0.06c-2.08,0-3.69,0.7-4.84,2.1C87.11,49.62,86.54,51.7,86.54,54.48z"/>
</svg>
);

const newUserIcon: React.SVGProps<SVGSVGElement> = (
  <svg viewBox="0 0 122.88 115.68" height="24">
    <path d="M99.56,69A23.33,23.33,0,1,1,76.23,92.35,23.32,23.32,0,0,1,99.56,69ZM37.16,55c-2-3.22-5.8-7.59-5.8-11.35a6.06,6.06,0,0,1,4.08-5.52c-.19-3.19-.32-6.42-.32-9.62,0-1.9,0-3.81.11-5.69a12.65,12.65,0,0,1,.64-2.85,20.22,20.22,0,0,1,9-11.48A25.93,25.93,0,0,1,49.8,6.1c3.1-1.13,1.6-6,5-6.1,8-.2,21,6.75,26.12,12.27a18.52,18.52,0,0,1,5.21,12.41l-.32,13.93a4.57,4.57,0,0,1,3.34,2.86c1.08,4.39-3.47,9.86-5.59,13.36-2,3.22-9.43,12-9.44,12.1a5.5,5.5,0,0,0,2.5,5,30.71,30.71,0,0,0-4.47,34.17H0c0-32.54,46.73-25.1,46.52-39.26,0-.2-8.59-10.72-9.36-11.94Zm58.48,27.2c0-1.16-.11-2,1.32-2l4.64,0c1.49,0,1.89.47,1.87,1.87v6.33h6.29c1.15,0,2-.12,2,1.31l-.06,4.64c0,1.5-.46,1.9-1.87,1.88h-6.32v6.32c0,1.4-.38,1.88-1.87,1.87l-4.64.05c-1.43,0-1.33-.8-1.32-2V96.27H89.32c-1.4,0-1.88-.38-1.87-1.88l-.06-4.64c0-1.43.81-1.32,2-1.31h6.29V82.15Z" />
  </svg>
);

const newUserIconSmall: React.SVGProps<SVGSVGElement> = (
  <svg viewBox="0 0 122.88 115.68" height="12">
    <path d="M99.56,69A23.33,23.33,0,1,1,76.23,92.35,23.32,23.32,0,0,1,99.56,69ZM37.16,55c-2-3.22-5.8-7.59-5.8-11.35a6.06,6.06,0,0,1,4.08-5.52c-.19-3.19-.32-6.42-.32-9.62,0-1.9,0-3.81.11-5.69a12.65,12.65,0,0,1,.64-2.85,20.22,20.22,0,0,1,9-11.48A25.93,25.93,0,0,1,49.8,6.1c3.1-1.13,1.6-6,5-6.1,8-.2,21,6.75,26.12,12.27a18.52,18.52,0,0,1,5.21,12.41l-.32,13.93a4.57,4.57,0,0,1,3.34,2.86c1.08,4.39-3.47,9.86-5.59,13.36-2,3.22-9.43,12-9.44,12.1a5.5,5.5,0,0,0,2.5,5,30.71,30.71,0,0,0-4.47,34.17H0c0-32.54,46.73-25.1,46.52-39.26,0-.2-8.59-10.72-9.36-11.94Zm58.48,27.2c0-1.16-.11-2,1.32-2l4.64,0c1.49,0,1.89.47,1.87,1.87v6.33h6.29c1.15,0,2-.12,2,1.31l-.06,4.64c0,1.5-.46,1.9-1.87,1.88h-6.32v6.32c0,1.4-.38,1.88-1.87,1.87l-4.64.05c-1.43,0-1.33-.8-1.32-2V96.27H89.32c-1.4,0-1.88-.38-1.87-1.88l-.06-4.64c0-1.43.81-1.32,2-1.31h6.29V82.15Z" />
  </svg>
);

const newOffer: React.SVGProps<SVGSVGElement> = (
  <svg x="0px" y="0px" viewBox="0 0 110.74 122.88" height="24">
    <g>
      <path d="M48.47,116.35c1.8,0,3.27,1.46,3.27,3.26c0,1.8-1.46,3.26-3.27,3.26H7.6c-2.09,0-3.99-0.85-5.37-2.23 C0.85,119.27,0,117.38,0,115.28V7.6C0,5.5,0.85,3.61,2.23,2.23C3.61,0.85,5.5,0,7.6,0h93.3c2.09,0,3.99,0.86,5.37,2.23 c1.38,1.38,2.23,3.27,2.23,5.37v53.95c0,1.8-1.46,3.26-3.26,3.26c-1.8,0-3.26-1.46-3.26-3.26V7.6c0-0.29-0.12-0.56-0.32-0.75 c-0.2-0.2-0.47-0.32-0.75-0.32H7.6c-0.29,0-0.56,0.12-0.76,0.31C6.65,7.05,6.53,7.31,6.53,7.6v107.68c0,0.29,0.12,0.56,0.32,0.75 c0.2,0.2,0.47,0.32,0.76,0.32L48.47,116.35L48.47,116.35L48.47,116.35z M33.94,57.92c-0.62-1.07-0.17-4.13,1.16-5.21 c3.8-2.22,9.04-1.53,12.7-4.09c0.21-0.32,0.44-0.78,0.67-1.29c0.33-0.76,0.64-1.59,0.83-2.16c-0.81-0.96-1.51-2.04-2.17-3.1 l-2.2-3.5c-0.8-1.2-1.22-2.3-1.25-3.2c-0.01-0.42,0.06-0.81,0.22-1.15c0.16-0.36,0.41-0.65,0.76-0.88c0.16-0.11,0.34-0.2,0.53-0.27 c-0.15-1.9-0.2-4.29-0.1-6.3c0.05-0.47,0.14-0.95,0.27-1.43c0.56-2.01,1.97-3.63,3.72-4.74c0.96-0.61,2.02-1.08,3.12-1.39 c0.7-0.2-0.6-2.43,0.13-2.51c3.5-0.36,9.15,2.83,11.59,5.47c1.22,1.32,1.99,3.08,2.16,5.4l-0.14,5.71l0,0 c0.61,0.19,1,0.57,1.16,1.2c0.18,0.7-0.01,1.67-0.61,3.01l0,0c-0.01,0.02-0.02,0.05-0.04,0.07l-2.51,4.13 c-0.92,1.52-1.86,3.04-3.08,4.24c0.11,0.16,0.23,0.32,0.34,0.48c0.5,0.73,1,1.46,1.64,2.11c0.02,0.02,0.04,0.05,0.05,0.07 c2.89,2.04,9.92,2.54,12.62,4.04l0.11,0.06c1.39,1.07,1.82,4.13,1.18,5.2H33.94L33.94,57.92z M102.29,79.04 c-0.53-0.51-1.14-0.75-1.84-0.74c-0.71,0.01-1.31,0.29-1.8,0.81l-4.05,4.22l11.37,10.98l4.09-4.26c0.49-0.5,0.69-1.14,0.68-1.84 c-0.01-0.69-0.26-1.33-0.76-1.8L102.29,79.04L102.29,79.04L102.29,79.04z M84.54,116.17c-1.5,0.48-3,0.97-4.49,1.46 c-1.5,0.5-3,1-4.49,1.5c-3.53,1.16-5.51,1.8-5.93,1.92c-0.4,0.12-0.17-1.53,0.73-4.99l2.81-10.83l0,0l17.82-18.18l11.36,10.93 L84.54,116.17L84.54,116.17L84.54,116.17z M31.74,95.36c-1.8,0-3.27-1.48-3.27-3.31s1.46-3.31,3.27-3.31h22.21 c1.8,0,3.27,1.48,3.27,3.31s-1.46,3.31-3.27,3.31H31.74L31.74,95.36L31.74,95.36z M31.74,74.67c-1.8,0-3.26-1.46-3.26-3.27 c0-1.8,1.46-3.26,3.26-3.26h44.05c1.8,0,3.26,1.46,3.26,3.26c0,1.8-1.46,3.27-3.26,3.27H31.74L31.74,74.67L31.74,74.67z" />
    </g>
  </svg>
);

const newOfferSmall: React.SVGProps<SVGSVGElement> = (
  <svg x="0px" y="0px" viewBox="0 0 110.74 122.88" height="12">
    <g>
      <path d="M48.47,116.35c1.8,0,3.27,1.46,3.27,3.26c0,1.8-1.46,3.26-3.27,3.26H7.6c-2.09,0-3.99-0.85-5.37-2.23 C0.85,119.27,0,117.38,0,115.28V7.6C0,5.5,0.85,3.61,2.23,2.23C3.61,0.85,5.5,0,7.6,0h93.3c2.09,0,3.99,0.86,5.37,2.23 c1.38,1.38,2.23,3.27,2.23,5.37v53.95c0,1.8-1.46,3.26-3.26,3.26c-1.8,0-3.26-1.46-3.26-3.26V7.6c0-0.29-0.12-0.56-0.32-0.75 c-0.2-0.2-0.47-0.32-0.75-0.32H7.6c-0.29,0-0.56,0.12-0.76,0.31C6.65,7.05,6.53,7.31,6.53,7.6v107.68c0,0.29,0.12,0.56,0.32,0.75 c0.2,0.2,0.47,0.32,0.76,0.32L48.47,116.35L48.47,116.35L48.47,116.35z M33.94,57.92c-0.62-1.07-0.17-4.13,1.16-5.21 c3.8-2.22,9.04-1.53,12.7-4.09c0.21-0.32,0.44-0.78,0.67-1.29c0.33-0.76,0.64-1.59,0.83-2.16c-0.81-0.96-1.51-2.04-2.17-3.1 l-2.2-3.5c-0.8-1.2-1.22-2.3-1.25-3.2c-0.01-0.42,0.06-0.81,0.22-1.15c0.16-0.36,0.41-0.65,0.76-0.88c0.16-0.11,0.34-0.2,0.53-0.27 c-0.15-1.9-0.2-4.29-0.1-6.3c0.05-0.47,0.14-0.95,0.27-1.43c0.56-2.01,1.97-3.63,3.72-4.74c0.96-0.61,2.02-1.08,3.12-1.39 c0.7-0.2-0.6-2.43,0.13-2.51c3.5-0.36,9.15,2.83,11.59,5.47c1.22,1.32,1.99,3.08,2.16,5.4l-0.14,5.71l0,0 c0.61,0.19,1,0.57,1.16,1.2c0.18,0.7-0.01,1.67-0.61,3.01l0,0c-0.01,0.02-0.02,0.05-0.04,0.07l-2.51,4.13 c-0.92,1.52-1.86,3.04-3.08,4.24c0.11,0.16,0.23,0.32,0.34,0.48c0.5,0.73,1,1.46,1.64,2.11c0.02,0.02,0.04,0.05,0.05,0.07 c2.89,2.04,9.92,2.54,12.62,4.04l0.11,0.06c1.39,1.07,1.82,4.13,1.18,5.2H33.94L33.94,57.92z M102.29,79.04 c-0.53-0.51-1.14-0.75-1.84-0.74c-0.71,0.01-1.31,0.29-1.8,0.81l-4.05,4.22l11.37,10.98l4.09-4.26c0.49-0.5,0.69-1.14,0.68-1.84 c-0.01-0.69-0.26-1.33-0.76-1.8L102.29,79.04L102.29,79.04L102.29,79.04z M84.54,116.17c-1.5,0.48-3,0.97-4.49,1.46 c-1.5,0.5-3,1-4.49,1.5c-3.53,1.16-5.51,1.8-5.93,1.92c-0.4,0.12-0.17-1.53,0.73-4.99l2.81-10.83l0,0l17.82-18.18l11.36,10.93 L84.54,116.17L84.54,116.17L84.54,116.17z M31.74,95.36c-1.8,0-3.27-1.48-3.27-3.31s1.46-3.31,3.27-3.31h22.21 c1.8,0,3.27,1.48,3.27,3.31s-1.46,3.31-3.27,3.31H31.74L31.74,95.36L31.74,95.36z M31.74,74.67c-1.8,0-3.26-1.46-3.26-3.27 c0-1.8,1.46-3.26,3.26-3.26h44.05c1.8,0,3.26,1.46,3.26,3.26c0,1.8-1.46,3.27-3.26,3.27H31.74L31.74,74.67L31.74,74.67z" />
    </g>
  </svg>
);

const Top: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const [isLoggedIn, setIsLoggedIn] = React.useState(false);
  const [timeLeft, setTimeLeft] = React.useState("1:00:00");
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [show, setShow] = useState(false);
  const [showLogOut, setShowLogOut] = useState(false);

  const open = Boolean(anchorEl);

  const userString = localStorage.getItem("user");
  const user = userString ? JSON.parse(userString) : null;
  const role = user?.role?.toLowerCase();

  const formatTime = (ms: number) => {
    const totalSeconds = Math.max(0, Math.floor(ms / 1000));
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    return `${hours}:${minutes.toString().padStart(2, "0")}:${seconds
      .toString()
      .padStart(2, "0")}`;
  };

  useEffect(() => {
    const updateSession = () => {
      const signInDate = localStorage.getItem("signin-date");
      const token = localStorage.getItem("token");
      const userData = localStorage.getItem("user");

      if (!signInDate || !token || !userData) {
        setIsLoggedIn(false);
        setTimeLeft("1:00:00");
        return;
      }

      const expireAt = moment(signInDate).add(1, "hour");
      const diff = expireAt.diff(moment());

      if (diff <= 0) {
        setIsLoggedIn(false);
        setTimeLeft("0:00:00");
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        localStorage.removeItem("signin-date");
        dispatch(logout());
        return;
      }

      setIsLoggedIn(true);
      setTimeLeft(formatTime(diff));
    };

    updateSession();
    const interval = setInterval(updateSession, 1000);

    return () => clearInterval(interval);
  }, [dispatch]);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCloseModal = () => setShow(false);
  const handleShowModal = () => setShow(true);
  const handleCloseModalLogOut = () => setShowLogOut(false);
  const handleShowModalLogOut = () => setShowLogOut(true);

  const LogOut = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("signin-date");
    dispatch(logout());
    handleCloseModalLogOut();
    setIsLoggedIn(false);
    setTimeLeft("1:00:00");
    history.push("/");
  };

  const userMenuItems =
    role === "admin"
      ? [
          {
            to: "/adminaddcompany",
            label: "Dodaj firmę jako admin",
            icon: <FaPlusCircle />,
          },
          {
            to: "/signup",
            label: "Dodaj użytkownika",
            icon: <FaUserPlus />,
          },
          {
            to: "/admin/users",
            label: "Użytkownicy",
            icon: <FaUsers />,
          },
          {
            to: "/admin/offers",
            label: "Wizytówki firm",
            icon: <FaBuilding />,
          },
          {
            to: "/admin/bills",
            label: "Rachunki",
            icon: <FaFileInvoiceDollar />,
          },
        ]
      : [
          {
            to: "/my-offers",
            label: "Moje firmy",
            icon: <FaBuilding />,
          },
          {
            to: "/my-bills",
            label: "Moje rachunki",
            icon: <FaFileInvoiceDollar />,
          },
          {
            to: "/addcompany",
            label: "Dodaj firmę",
            icon: <FaPlusCircle />,
          },
        ];

  return (
    <div className={style.Content}>
      <div className={style.Header}>
        <NavLink
          to={"/"}
          className={style.MenuItem}
          style={{ textDecoration: "none" }}
        >
          <div className={style.LogoBox}>
            <img
              src={logoCartena}
              alt="CARTENA"
              className={style.LogoImage}
            />

            <img
              src={logoCartenaHover}
              alt=""
              className={style.LogoImageHover}
            />
          </div>
        </NavLink>

        <div className={style.Menu}>
          <NavLink
            key={"offer"}
            exact
            to={"/offer"}
            className={style.MenuItem}
            style={{ textDecoration: "none" }}
          >
            Oferta
          </NavLink>
          <div>|</div>
          <NavLink
            key={"order"}
            exact
            to={"/how-to-order"}
            className={style.MenuItem}
            style={{ textDecoration: "none" }}
          >
            Jak zamówić transport?
          </NavLink>
          <div>|</div>
          <NavLink
            key={"banned"}
            exact
            to={"/banned"}
            className={style.MenuItem}
            style={{ textDecoration: "none" }}
          >
            Zakazy jazdy samochodów ciężarowych
          </NavLink>
          <div>|</div>
          <NavLink
            key={"contact"}
            exact
            to={"/contact"}
            className={style.MenuItem}
            style={{ textDecoration: "none" }}
          >
            Kontakt
          </NavLink>
        </div>
      </div>

      <div className={style.LogInButton}>
        <div className={style.LeftSection}>
          {isLoggedIn ? (
            <>
              <div className={style.SessionBox}>Sesja: {timeLeft}</div>

              <div className={style.LogIn} onClick={handleShowModal}>
                {userIcon}
              </div>

              <div className={style.LogInSmall} onClick={handleShowModal}>
                {userSmallIcon}
              </div>

              <div className={style.LogIn} onClick={handleShowModalLogOut}>
                <button type="button" className={style.LoginButton}>
                  <span>WYLOGUJ</span>
                  {logoutIcon}
                </button>
              </div>

              <div className={style.LogInSmall} onClick={handleShowModalLogOut}>
                <button type="button" className={style.LoginButtonSmall}>
                  <span>WYLOGUJ</span>
                  {logoutIconSmall}
                </button>
              </div>
            </>
          ) : (
            <>
              {/* DUŻY EKRAN */}
              <NavLink
                key="login"
                exact
                to="/signin"
                style={{ textDecoration: "none" }}
                className={style.LoginDesktop}
              >
                <button type="button" className={style.LoginButton}>
                  <span>ZALOGUJ</span>
                  {loginIcon}
                </button>
              </NavLink>

              {/* MAŁY EKRAN */}
              <NavLink
                key="login-small"
                exact
                to="/signin"
                style={{ textDecoration: "none" }}
                className={style.LoginMobile}
              >
                <button type="button" className={style.LoginButtonSmall}>
                  <span>ZALOGUJ</span>
                  {loginIconSmall}
                </button>
              </NavLink>
            </>
          )}
        </div>
        <div className={style.MenuSmall}>
          <Butt
            size="small"
            color="primary"
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            onClick={handleClick}
          >
            <span className={style.MenuSmallContent}>
              <MdMenu />
              <span>MENU</span>
            </span>
          </Butt>

          <Menu
            id="demo-positioned-menu"
            aria-labelledby="demo-positioned-button"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
          >
            <NavLink
              key={"offer"}
              exact
              to={"/offer"}
              style={{ textDecoration: "none" }}
              className={style.MenuItem}
            >
              <MenuItem onClick={handleClose}>Oferta</MenuItem>
            </NavLink>

            <NavLink
              key={"order"}
              exact
              to={"/how-to-order"}
              style={{ textDecoration: "none" }}
              className={style.MenuItem}
            >
              <MenuItem onClick={handleClose}>Jak zamówić transport?</MenuItem>
            </NavLink>

            <NavLink
              key={"banned"}
              exact
              to={"/banned"}
              style={{ textDecoration: "none" }}
              className={style.MenuItem}
            >
              <MenuItem onClick={handleClose}>
                Zakazy jazdy samochodów powyżej 3,5T
              </MenuItem>
            </NavLink>

            <NavLink
              key={"contact"}
              exact
              to={"/contact"}
              style={{ textDecoration: "none" }}
              className={style.MenuItem}
            >
              <MenuItem onClick={handleClose}>Kontakt</MenuItem>
            </NavLink>
          </Menu>
        </div>

        <Modal show={show} onHide={handleCloseModal} centered className={style.UserModal}>
          <Modal.Header closeButton className={style.UserModalHeader}>
            <Modal.Title className={style.UserModalTitle}>
              Witaj {user?.name || ""}
            </Modal.Title>
          </Modal.Header>

          <Modal.Body className={style.UserModalBody}>
            <div className={style.UserCard}>
              <div className={style.UserCardTop}>
                <div className={style.UserAvatar}>
                  {role === "admin" ? newUserIcon : userIcon}
                </div>

                <div className={style.UserDetails}>
                  <div className={style.UserName}>
                    {user?.name || "Użytkownik"}
                  </div>

                  <div className={style.UserRole}>
                    {role === "admin" ? "Administrator" : "Użytkownik"}
                  </div>

                  <div className={style.UserEmailModal}>
                    Email: {user?.email}
                  </div>

                  {role === "user" && (
                    <div className={style.UserCredit}>
                      Saldo:{" "}
                      <strong>
                        {Number(user?.outstandingBalance ?? 0).toLocaleString("pl-PL", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}{" "}
                        PLN
                      </strong>
                    </div>
                  )} 
                </div>
              </div>
            </div>

            <div className={style.UserActions}>
              <div className={style.UserActionsTitle}>Dostępne opcje</div>

              <div className={style.UserActionsList}>
                {userMenuItems.map((item) => (
                  <NavLink
                    key={item.to}
                    exact
                    to={item.to}
                    className={style.UserActionItem}
                    onClick={() => {
                      if (item.to === "/my-offers") {
                        dispatch(clearCompanies());
                      }
                      handleCloseModal();
                    }}
                  >
                    <span className={style.UserActionIcon}>{item.icon}</span>
                    <span className={style.UserActionText}>{item.label}</span>
                  </NavLink>
                ))}
              </div>
            </div>
          </Modal.Body>

          <Modal.Footer className={style.UserModalFooter}>
            <ButtonModal variant="secondary" onClick={handleCloseModal}>
              Zamknij
            </ButtonModal>
          </Modal.Footer>
        </Modal>

        <Modal
          show={showLogOut}
          onHide={handleCloseModalLogOut}
          centered
          className={style.UserModal}
        >
          <Modal.Header closeButton className={style.UserModalHeader}>
            <Modal.Title className={style.UserModalTitle}>
              Wylogowanie
            </Modal.Title>
          </Modal.Header>

          <Modal.Body className={style.LogoutModalBody}>
            Czy na pewno chcesz się wylogować?
          </Modal.Body>

          <Modal.Footer className={style.UserModalFooter}>
            <ButtonModal variant="outline-secondary" onClick={handleCloseModalLogOut}>
              Anuluj
            </ButtonModal>
            <ButtonModal variant="danger" onClick={LogOut}>
              Wyloguj
            </ButtonModal>
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
};

export default Top;